<template>
  <hm-content title="促销列表">
    <div slot="header">
      <hm-step
        :steps="steps"
        :step="currentStep"
        :disabledFirst="disabledFirst"
        disabledNext
      ></hm-step>
    </div>
    <div>
      <div class="selected-activity caption">
        <span class="mr10">促销内容</span>
        <span class="primary activity">({{ childTypeName }})</span>
      </div>
      <!-- 满额减件数金额 -->
      <div class="way" v-if="parentId === 'FullReduction'">
        <div class="flex">
          <div class="title">优惠方式</div>
          <div class="way-list">
            <div class="flex way-item">
              <div class="item mr20">
                每买满
                <el-input
                  v-model="calcCondition"
                  @input="filterGt0OrFixed2('calcCondition')"
                  type="number"
                ></el-input>
                <span v-if="childId === 'PriceReduction'">元</span>
                <span v-if="childId === 'NumReduction'">件</span>
              </div>
              <div class="item mr20">
                立减
                <el-input
                  v-model="discountResult"
                  @input="filterGt0OrFixed2('discountResult')"
                  type="number"
                ></el-input
                >元
              </div>
              <div class="item mr20">
                最多循环
                <el-input
                  v-model="cyclesTimes"
                  @input="filterGt0('cyclesTimes')"
                  type="number"
                ></el-input
                >次
              </div>
              <div class="add-wrapper">
                <span
                  class="hmicon icon-hao pointer"
                  @click="addItem('fullReductionRule')"
                  :disabled="fullReductionRule.length >= 20"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="title">已选优惠</div>
          <div class="way-list">
            <div
              class="flex way-item item-center"
              v-for="(v, i) in fullReductionRule"
              :key="i"
            >
              <div class="item mr20">
                每买满
                <span class="primary">{{ v.calcCondition }}</span>
                <span v-if="childId === 'PriceReduction'">元</span>
                <span v-if="childId === 'NumReduction'">件</span>
              </div>
              <div class="item mr20">
                立减
                <span class="primary">{{ v.discountResult }}</span
                >元
              </div>
              <div class="item mr20">
                最多循环
                <span class="primary">{{ v.cyclesTimes }}</span
                >次
              </div>
              <div class="item mr20">
                <div class="minus-wrapper">
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteItem('fullReductionRule', i)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 满件数送商品，满金额送商品 -->
      <div class="way" v-if="parentId === 'FullDelivery'">
        <div class="flex flex-between item-center panel way-item">
          <div class="flex">
            <div class="mr20">
              捆绑方式：
              <el-select
                style="width: 100px"
                v-model="selectType"
                placeholder="请选择捆绑方式"
              >
                <el-option label="混合" value="mix"></el-option>
                <el-option label="同品" value="same"></el-option>
              </el-select>
            </div>
            <div class="item mr20">
              每买满
              <el-input
                v-model="purchasesAmount"
                @input="filterGt0OrFixed2('purchasesAmount')"
                :disabled="Boolean(fullDeliveryGoods.length)"
                type="number"
              ></el-input>
              <span v-if="childId === 'PriceDelivery'">元</span>
              <span v-if="childId === 'NumDelivery'">件</span>
            </div>
            <!-- 同品模式 -->
            <div v-if="selectType === 'same'" class="flex">
              <div class="item mr20 flex item-center">送必选同品如下</div>
              <!-- <div class="item mr20 flex item-center">
                送可选商品
                <el-input v-model="chooseDeliveryAmount" size="small"></el-input
                >件
              </div> -->
            </div>
            <!-- 混合模式 -->
            <div v-if="selectType === 'mix'" class="flex">
              <div class="item mr20 flex item-center">
                送可选商品
                <el-input
                  v-model="chooseDeliveryAmount"
                  @change="fullDeliveryResult = []"
                  @input="filterGt0('chooseDeliveryAmount')"
                  size="small"
                ></el-input
                >件
              </div>
              <div
                class="item mr20 flex item-center"
                v-if="fullDeliveryGoods.length <= 2"
              >
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addItem('fullDelivery')"
                  ></span>
                </div>
              </div>
              <div
                class="item mr20 flex item-center"
                v-show="fullDeliveryGoods.length"
              >
                <div>已选规则：</div>
                <div
                  class="flex item-center mr20"
                  v-for="(v, i) in fullDeliveryGoods"
                  :key="i"
                >
                  <span v-show="i === 0">送</span>
                  <span v-show="i > 0">加送</span>
                  <span class="primary">{{ v.selectLowerLimit }}</span
                  >件
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb20" v-show="selectType !== 'same'">
          赠送商品价格：
          <el-switch
            v-model="giftLimit"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="yes"
            active-text="买高送低"
            inactive-text="不限"
            inactive-value="no"
          ></el-switch>
        </div>
        <div class="flex flex-between">
          <el-button type="primary" @click="showTransfer" size="small"
            >添加商品</el-button
          >
          <div>
            <el-input
              v-model="batchSelectUpperLimit"
              @input="filterGt0('batchSelectUpperLimit')"
              size="small "
              placeholder="批量设置赠送上限"
              style="width:300px"
              clearable
            >
              <el-button
                slot="append"
                icon="hmicon icon-jia"
                @click="batchUpperLimit"
              ></el-button>
            </el-input>

            <el-input
              class="ml10"
              size="small"
              v-model="keywords"
              @input="filterDeliveryGoods"
              placeholder="货号/商品关键字"
              suffix-icon="hmicon icon-search"
            ></el-input>
          </div>
        </div>
        <div
          class="flex flex-between mt20 p10"
          style="border:1px solid #EBEEF5;border-bottom:none"
        >
          <div></div>
          <div>促销商品</div>
          <div @click="deleteSelectedFullDelivery" class="delete pointer">
            <span class="delete-icon hmicon icon-shanchu"></span>
            删除
          </div>
        </div>

        <el-table
          stripe
          border
          :data="fullDeliveryResult"
          style="width: 100%"
          class=" mb20"
          id="table"
          @selection-change="handleCheckAllChange"
          size="small"
          max-height="300"
        >
          <el-table-column
            type="selection"
            :selectable="selectable"
          ></el-table-column>
          <!-- <el-table-column type="index" label="序号"></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="attrType"
            label="类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'brand'">
                添加品牌
              </div>
              <div v-if="scope.row.attrType === 'goods'">
                添加商品
              </div>
              <div v-if="scope.row.attrType === 'barcode'">
                添加sku商品
              </div>
              <div v-if="scope.row.attrType === 'category'">
                添加品类
              </div>
              <div v-if="scope.row.attrType === 'attribute'">
                添加属性
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="attrType"
            label="编号（只显示商品货号/条码）"
            width="200"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'goods'">
                货号:{{ scope.row.attrId }}
              </div>
              <div v-else-if="scope.row.attrType === 'barcode'">
                条码:{{ scope.row.attrId }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="attrValue"
            label="名称"
            width="500"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopPrices"
            label="零售价"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useable"
            label="状态"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.useable === 'white'"
                class="select-type white"
                >白</span
              >
              <span
                v-if="scope.row.useable === 'black'"
                class="select-type black"
                >黑</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="selectUpperLimit"
            label="赠送上限"
          >
            <template slot-scope="scope">
              <el-input
                clearable
                style="width: 80px"
                v-model.trim="scope.row.selectUpperLimit"
                @input="filterInteger(scope.row.selectUpperLimit, scope.$index)"
                placeholder=""
                size="small"
                class="ipt"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                content="删除"
                placement="top"
                v-show="!scope.row.isSame"
              >
                <div
                  class="pointer mr10"
                  @click="
                    deleteCurrentDeliveryGoods(
                      scope.row.selectUpperLimit,
                      scope.$index
                    )
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="false" class="table">
          <div class="table-out-header flex flex-between">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <div>促销商品</div>
            <div @click="deleteSelectedFullDelivery" class="delete">
              <span class="delete-icon hmicon icon-shanchu"></span>
              删除
            </div>
          </div>
          <div class="table-header flex flex-between">
            <div class="flex-1 num">编号（只显示商品货号/条码）</div>
            <div class="flex-3 text-center">名称</div>
            <div class="flex-1 text-center">商品数量</div>
            <!-- <div class="flex-1 text-center">状态(<span class="danger">红色</span>可选|<span class="success">绿色</span>必选)</div> -->
            <!--  -->
            <div class="flex-1 text-center">赠送上限</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="calcCondition-height: 500px;"
            >
              <el-checkbox-group
                v-model="checkedGoods"
                @change="handleCheckedGoodsChange"
              >
                <div
                  class="list-item"
                  v-for="(v, i) in fullDeliveryResult"
                  :key="i"
                >
                  <div class="row flex flex-between">
                    <el-checkbox
                      :label="v"
                      class="flex-4 flex item-center"
                      :disabled="v.isSame"
                    >
                      <div class="flex flex-1">
                        <el-tooltip
                          :content="
                            v.attrType === 'barcode'
                              ? `条码：${v.barcode}`
                              : `货号：${v.goodsSn}`
                          "
                          placement="top"
                        >
                          <div class="flex attrid flex-1 item-center">
                            {{
                              v.attrType === "barcode"
                                ? `条码：${v.barcode}`
                                : `货号：${v.goodsSn}`
                            }}
                          </div>
                        </el-tooltip>
                        <el-tooltip
                          :content="v.goodsName || v.attrValue"
                          placement="top"
                        >
                          <div
                            style="width:400px"
                            class="text-overflow flex flex-3 text-center flex-center item-center"
                          >
                            {{ v.goodsName || v.attrValue }}
                          </div>
                        </el-tooltip>
                      </div>
                    </el-checkbox>
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      {{ v.goodsPackageNum }}
                    </div>
                    <!-- <div class="flex-1  text-center  flex flex-center item-center">
                      <el-switch v-model="v.isMustDelivery"
                                 size="mini"
                                 v-if="selectType === 'mix'"
                                 @change="swithcSelect"
                                 active-color="#13ce66"
                                 inactive-color="#ff4949"
                                 active-value="yes"
                                 inactive-value="no">
                      </el-switch>
                    </div>-->
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <div class="el-input el-input el-input--small">
                        <input
                          type="number"
                          class="el-input__inner"
                          style="width: 80px"
                          size="small"
                          @input="filterInteger(v.selectUpperLimit, i)"
                          v-model="v.selectUpperLimit"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <span
                        v-show="!v.isSame"
                        @click="deleteCurrentDeliveryGoods(v, i)"
                        class="primary delete-icon hmicon icon-shanchu"
                      ></span>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div
              class="no-message text-center"
              v-show="!fullDeliveryResult.length"
            >
              请添加商品!
            </div>
          </div>
        </div>
        <div v-if="fullDeliveryGoods.length">
          <div v-for="(v, i) in fullDeliveryGoods" :key="i">
            <div class="flex item-center">
              <div class="list-item mb20">
                <div class="flex mb20">
                  <span v-show="i === 0">送</span>
                  <span v-show="i > 0">加送</span>
                  <span class="primary">{{ v.selectLowerLimit }}</span
                  >件
                </div>
                <el-table
                  :data="v.groupGoods"
                  size="small"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="货号"
                    width="150"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.attrId || scope.row.goodsSn }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名"
                    header-align="center"
                    align="center"
                    width="300"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.attrValue || scope.row.goodsName }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="shopPrices"
                    header-align="center"
                    align="center"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    prop="goodsPackageNum"
                    header-align="center"
                    align="center"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    prop="selectUpperLimit"
                    header-align="center"
                    align="center"
                    label="换购上限"
                  ></el-table-column>
                </el-table>
              </div>
              <div class="minus-wrapper">
                <span
                  class="hmicon icon-jianhao pointer"
                  @click="deleteItem('fullDeliveryGoods', i)"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 满件数加价换购 -->
      <div class="way" v-if="parentId === 'IncreasePurchase'">
        <div class="flex way-item">
          <div class="item mr20">
            每买满
            <el-input v-model="purchasesAmount" type="number"></el-input>
            <span v-if="childId === 'NumIncrease'">件</span>
            <span v-if="childId === 'PriceIncrease'">元</span>
          </div>
          <div class="item mr20">
            加
            <el-input
              v-model="markupFee"
              @input="filterGt0OrFixed2('markupFee')"
              type="number"
            ></el-input
            >元
          </div>
          <div class="item mr20 flex item-center">
            换购
            <el-input
              v-model="exchangePurchasesUpperAmount"
              @input="filterGt0('exchangePurchasesUpperAmount')"
              type="number"
            ></el-input>
            <!-- <span class="primary">{{exchangePurchasesUpperAmount}}</span> -->
            件
          </div>
          <div class="add-wrapper">
            <span
              class="hmicon icon-hao pointer"
              @click="addItem('increasePurchaseRules')"
              :disabled="increasePurchaseRules.length >= 20"
            ></span>
          </div>
        </div>

        <div class="flex flex-between">
          <el-button type="primary" @click="dialogVisible = true" size="small"
            >添加商品</el-button
          >
          <el-input
            size="small"
            v-model="keywords"
            @input="filterIncreaseGoods"
            placeholder="货号/商品关键字"
            suffix-icon="hmicon icon-search"
          ></el-input>
        </div>
        <div class="table">
          <div class="table-out-header flex flex-between">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <div>已选商品</div>
            <div @click="deleteSelectedIncreasePurchase" class="delete">
              <span class="delete-icon hmicon icon-shanchu"></span>
              删除
            </div>
          </div>
          <div class="table-header flex flex-between">
            <div class="flex-1 num">商品货号</div>
            <div class="flex-3 text-center">商品名</div>
            <div class="flex-1 text-center">商品数量</div>
            <div class="flex-1 text-center">换购上限</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="calcCondition-height: 500px;"
            >
              <el-checkbox-group
                v-model="checkedGoods"
                @change="handleCheckedGoodsChange"
              >
                <div
                  class="list-item"
                  v-for="(v, i) in increasePurchaseResult"
                  :key="i"
                >
                  <div class="row flex flex-between">
                    <el-checkbox :label="v" class="flex-4 flex item-center">
                      <div class="flex flex-1">
                        <div class="flex flex-1">{{ v.attrId }}</div>
                        <div
                          class="flex flex-3 flex-center text-overflow"
                          style="padding-left: 10px;box-sizing:border-box"
                        >
                          {{ v.attrValue }}
                        </div>
                      </div>
                    </el-checkbox>
                    <div class="flex flex-1 flex-center item-center">
                      {{ v.goodsPackageNum }}
                    </div>
                    <div class="flex flex-1 flex-center">
                      <div class="el-input el-input--small">
                        <input
                          type="number"
                          style="width: 50px"
                          class="el-input__inner"
                          v-show="v.attrType === 'goods'"
                          @input="
                            filterIntegerByIncrease(v.selectUpperLimit, i)
                          "
                          v-model="v.selectUpperLimit"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-1 text-center"
                      @click="deleteCurrentIncreasePurchase(v, i)"
                    >
                      <span
                        class="primary delete-icon hmicon icon-shanchu"
                      ></span>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div
              class="no-message text-center"
              v-show="!increasePurchaseResult.length"
            >
              请添加商品!
            </div>
          </div>
        </div>
        <div v-for="(v, i) in increasePurchaseRules" :key="i">
          <div class="flex item-center">
            <div class="list-item mb20">
              <div class="flex mb20">
                <div class="item mr20">
                  每买满
                  <span class="primary">{{ v.purchasesAmount }}</span>
                  <span v-if="childId === 'NumIncrease'">件</span>
                  <span v-if="childId === 'PriceIncrease'">元</span>
                </div>
                <div class="item mr20">加{{ v.markupFee }}元</div>
                <div class="item mr20 flex item-center">
                  换购
                  <span class="primary">{{
                    v.exchangePurchasesUpperAmount
                  }}</span
                  >件
                </div>
              </div>
              <el-table
                :data="v.purchaseGoodsList"
                size="small"
                stripe
                border
                style="width: 100%"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="货号"
                  width="150"
                >
                  <template slot-scope="scope">
                    {{ scope.row.attrId || scope.row.goodsSn }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="商品名"
                  header-align="center"
                  align="center"
                  width="300"
                >
                  <template slot-scope="scope">
                    {{ scope.row.attrValue || scope.row.goodsName }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="shopPrices"
                  header-align="center"
                  align="center"
                  label="零售价"
                ></el-table-column>
                <el-table-column
                  prop="goodsPackageNum"
                  header-align="center"
                  align="center"
                  label="商品数量"
                ></el-table-column>
                <el-table-column
                  prop="selectUpperLimit"
                  header-align="center"
                  align="center"
                  label="换购上限"
                ></el-table-column>
              </el-table>
            </div>
            <div class="minus-wrapper">
              <span
                class="hmicon icon-jianhao pointer"
                @click="deleteItem('increasePurchaseRules', i)"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 满件数打折 -->
      <div class="way" v-if="parentId === 'FullDiscount'">
        <div class="way-item">
          <div class="flex">
            <div class="title">折扣形式</div>
            <div class="content">
              <div class="flex item-center mb20">
                <el-radio-group v-model="discountMode">
                  <el-radio label="fullPriceDiscount">整单打折</el-radio>
                  <el-radio label="floorPriceDiscount">最低价打折</el-radio>
                </el-radio-group>
              </div>
              <!-- 整单打折 -->
              <div v-if="discountMode === 'fullPriceDiscount'">
                <div class="flex">
                  <div class="item mr20">
                    每买满
                    <el-input
                      v-model="purchasesAmount"
                      @input="filterGt0('purchasesAmount')"
                      type="number"
                    ></el-input>
                    <span v-if="childId === 'PriceDiscount'">元</span>
                    <span v-if="childId === 'NumDiscount'">件</span>
                  </div>
                  <div class="item mr20">
                    整单打
                    <el-input
                      v-model="discountRatio"
                      @input="filterGtrFixed2('discountRatio')"
                      type="number"
                    ></el-input
                    >折
                  </div>
                  <div class="add-wrapper">
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addItem('fullDiscountRule')"
                      :disabled="fullDiscountRule.lengh >= 20"
                    ></span>
                  </div>
                </div>
              </div>
              <!-- 最低价打折 -->
              <div v-if="discountMode === 'floorPriceDiscount'">
                <div class="flex">
                  <div class="item mr20">
                    每买满
                    <el-input
                      v-model="purchasesAmount"
                      @input="filterGt0('purchasesAmount')"
                      type="number"
                    ></el-input>
                    <span v-if="childId === 'PriceDiscount'">元</span>
                    <span v-if="childId === 'NumDiscount'">件</span>
                  </div>
                  <div class="item mr20">
                    最低价商品打
                    <el-input v-model="discountRatio" type="number"></el-input
                    >折
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" v-if="discountMode === 'fullPriceDiscount'">
            <div class="title">已选折扣</div>
            <div class="content">
              <div>
                <div
                  class="flex way-item item-center"
                  v-for="(v, i) in fullDiscountRule"
                  :key="i"
                >
                  <div class="item mr20">
                    每买满
                    <span class="primary">{{ v.purchasesAmount }}</span>
                    <span v-if="childId === 'PriceDiscount'">元</span>
                    <span v-if="childId === 'NumDiscount'">件</span>
                  </div>
                  <div class="item mr20">
                    整单打
                    <span class="primary">{{ v.discountRatio }}</span
                    >折
                  </div>
                  <div class="item mr20">
                    <div class="minus-wrapper">
                      <span
                        class="hmicon icon-jianhao pointer"
                        @click="deleteItem('fullDiscountRule', i)"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 特价 -->
      <div class="way" v-if="parentId === 'SpecialPrice'">
        <div class="flex flex-between">
          <el-button
            type="primary"
            @click="
              dialogVisible = true;
              showBarcode = true;
            "
            size="small"
            >添加商品</el-button
          >
          <div>
          <el-switch
            v-model="showUpperNum"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="10"
            active-text=""
            inactive-text=""
            inactive-value="999999"
          ></el-switch>
          限购10个及以下向用户展示
          <el-input
            class="ml20"
            size="small"
            v-model="keywords"
            @input="filterSpecialGoods"
            placeholder="货号/商品关键字"
            suffix-icon="hmicon icon-search"
          ></el-input>
          </div>
        </div>

        <div class="tables">
          <div class="flex flex-end mb10">
            <div class="flex">
              <div class="delete mr20 pointer open-file">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入 <span class="danger">（仅支持货号导入）</span>
                <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
              <div @click="outputExcel" class="delete pointer  mr20">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出
              </div>
              <div @click="showBatchDialog" class="delete pointer mr20">
                <span class="delete-icon hmicon icon-xitong"></span>
                批量设置
              </div>
              <div @click="deleteSelectedListHot" class="delete pointer mr20">
                <span class="delete-icon hmicon icon-shanchu"></span>
                删除
              </div>
            </div>
          </div>
          <el-table
            @selection-change="getChecked"
            stripe
            border
            ref="listHot"
            :data="listHot"
            style="width: 100%"
            id="table"
            size="small"
            :max-height="500"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              width="200px"
              prop="goodsSn"
              show-overflow-tooltip
              label="商品货号/条码"
            >
              <template slot-scope="scope">
                {{
                  scope.row.attrType === "barcode"
                    ? `条码：${scope.row.barcode}`
                    : `货号：${scope.row.goodsSn}`
                }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              show-overflow-tooltip
              label="商品名"
            ></el-table-column>
         
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsPackageNum"
              show-overflow-tooltip
              label="商品数量"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="purchasesUpperLimit"
              show-overflow-tooltip
              label="单人限购"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="small"
                  style="width:80px"
                  @input="filter(scope.row, 'purchasesUpperLimit')"
                  v-model="scope.row.purchasesUpperLimit"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalStockNum"
              show-overflow-tooltip
              label="促销库存"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="small"
                  style="width:80px"
                  @input="filter(scope.row, 'totalStockNum', 'points')"
                  v-model="scope.row.totalStockNum"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shopPrices"
              show-overflow-tooltip
              label="零售价"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="discountRatio"
              show-overflow-tooltip
              label="折扣率"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="small"
                  style="width:80px"
                  @change="
                    getDiscountPrice(scope.row.discountRatio, scope.$index)
                  "
                  @input="filter(scope.row, 'discountRatio', 'minus')"
                  v-model="scope.row.discountRatio"
                ></el-input
                >折
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="discountPrice"
              show-overflow-tooltip
              label="折扣价"
            >
              <template slot-scope="scope">
                <el-input
                  clearable
                  size="small"
                  style="width:80px"
                  @change="getDiscount(scope.row.discountPrice, scope.$index)"
                  @input="filter(scope.row, 'discountPrice', 'minus')"
                  v-model="scope.row.discountPrice"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <el-tooltip class="item" content="删除" placement="top">
                  <div
                    class="pointer mr10"
                    @click="deleteCurrentListHot(scope.row, scope.$index)"
                  >
                    <span class="hmicon icon-shanchu primary"></span>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="table">
          <div class="table-out-header flex flex-between">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <div>已选商品</div>
            <div class="flex">
              <div class="delete mr20 open-file">
                <span class="delete-icon hmicon icon-daoru"></span>
                导入
                <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
              <div @click="outputExcel" class="delete mr20">
                <span class="delete-icon hmicon icon-daochu"></span>
                导出
              </div>
              <div @click="showBatchDialog" class="delete mr20">
                <span class="delete-icon hmicon icon-xitong"></span>
                批量设置
              </div>
              <div @click="deleteSelectedListHot" class="delete mr20">
                <span class="delete-icon hmicon icon-shanchu"></span>
                删除
              </div>
            </div>
          </div>
          <div class="table-header flex flex-between">
            <div class="flex-1 num">商品货号</div>
            <div class="flex-3 text-center">商品名</div>
            <div class="flex-1 text-center">商品数量</div>
            <div class="flex-1 text-center">单人限购</div>
            <div class="flex-1 text-center">促销库存</div>
            <div class="flex-1 text-center">零售价</div>
            <div class="flex-1 text-center">折扣率</div>
            <div class="flex-1 text-center">折扣价</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="calcCondition-height: 500px;"
            >
              <el-checkbox-group
                v-model="checkedGoods"
                @change="handleCheckedGoodsChange"
              >
                <div class="list-item" v-for="(v, i) in listHot" :key="i">
                  <div class="row flex flex-between">
                    <el-checkbox :label="v" class="flex item-center flex-4">
                       <el-tooltip :content="v.goodsSn" placement="top">
                      <div class=" attrid flex flex-1" style="paddingLeft:10px">
                        {{ v.goodsSn }}
                      </div>
                       </el-tooltip>
                      <el-tooltip :content="v.goodsName" placement="top">

                      <div class="flex-3">
                        <span
                          class="text-overflow"
                          style="display: inline-block; width: 300px;textAlign: center"
                          >{{ v.goodsName }}
                        </span>
                      </div>
                      </el-tooltip>

                    </el-checkbox>
                    <div class="flex flex-1 flex-center item-center">
                      {{ v.goodsPackageNum }}
                    </div>
                    <div class="flex flex-1 flex-center">

                      <div class="el-input el-input--small" style="width:80px">
                        <input
                          type="number"
                          @input="filter(v, 'purchasesUpperLimit')"
                          class="el-input__inner"
                          v-model="v.purchasesUpperLimit"
                        />
                      </div>
                    </div>
                    <div class="flex flex-1 flex-center">

                      <div class="el-input el-input--small" style="width:80px">
                        <input
                          type="number"
                          @input="filter(v, 'totalStockNum', 'points')"
                          class="el-input__inner"
                          v-model="v.totalStockNum"
                        />
                      </div>
                    </div>
                    <div class="flex flex-1 flex-center item-center">
                      {{ v.shopPrices }}
                    </div>
                    <div class="flex flex-1 flex-center">

                      <div class="el-input el-input--small" style="width:80px">
                        <input
                          type="number"
                          @input="filter(v, 'discountRatio', 'minus')"
                          class="el-input__inner"
                          @change="getDiscountPrice(v.discountRatio, i)"
                          v-model="v.discountRatio"
                        />
                      </div>
                    </div>
                    <div class="flex flex-1 flex-center">
                      <div class="el-input el-input--small" style="width: 80px">
                        <input
                          type="number"
                          @input="filter(v, 'discountPrice', 'minus')"
                          class="el-input__inner"
                          @change="getDiscount(v.discountPrice, i)"
                          v-model="v.discountPrice"
                        />
                      </div>

                    </div>
                    <div
                      class="flex-1 text-center item-center"
                      @click="deleteCurrentListHot(v, i)"
                    >
                      <span
                        class="primary delete-icon hmicon icon-shanchu"
                      ></span>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div class="no-message text-center" v-show="!listHot.length">
              请添加商品!
            </div>
          </div>
        </div> -->
      </div>
      <!-- 打包价 -->
      <div class="way" v-if="parentId === 'CombinationPrice'">
        <div class="flex way-item">
          <div class="item mr20">
            每买满
            <el-input
              v-model="purchasesAmount"
              @input="filterGt0('purchasesAmount')"
              type="number"
            ></el-input
            >件
          </div>
          <div class="item mr20">
            组合价格
            <el-input
              v-model="combinationPrice"
              @input="filterGt0OrFixed2('combinationPrice')"
              type="number"
            ></el-input
            >元
          </div>
          <div class="add-wrapper">
            <span
              class="hmicon icon-hao pointer"
              @click="addItem('combinationPriceRules')"
              :disabled="combinationPriceRules.length >= 20"
            ></span>
          </div>
        </div>
        <div
          class="flex item-center mb20"
          v-for="(v, i) in combinationPriceRules"
          :key="i"
        >
          <div class="mr20">
            满
            <span class="primary">{{ v.purchasesAmount }}</span
            >件
          </div>
          <div class="mr20">
            组合价格
            <span class="primary">{{ v.combinationPrice }}</span
            >元
          </div>
          <div class="minus-wrapper">
            <span
              class="hmicon icon-jianhao pointer"
              @click="deleteItem('combinationPriceRules', i)"
            ></span>
          </div>
        </div>
        <div class="flex flex-between">
          <el-button
            type="primary"
            @click="
              dialogVisible = true;
              showBarcode = true;
            "
            size="small"
            >添加商品</el-button
          >
          <el-input
            size="small"
            v-model="keywords"
            @input="filterDeliveryGoods"
            placeholder="货号/商品关键字"
            suffix-icon="hmicon icon-search"
          ></el-input>
        </div>
        <div class="table">
          <div class="table-out-header flex flex-between">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <div>已选商品</div>
            <div @click="deleteSelectedCombination" class="delete">
              <span class="delete-icon hmicon icon-shanchu"></span>
              删除
            </div>
          </div>
          <div class="table-header flex flex-between">
            <div class="flex-1 num">商品货号/条码</div>
            <div class="flex-3 text-center">商品名</div>
            <div class="flex-1 text-center">数量</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="calcCondition-height: 500px;"
            >
              <el-checkbox-group
                v-model="checkedGoods"
                @change="handleCheckedGoodsChange"
              >
                <div
                  class="list-item"
                  v-for="(v, i) in combinationResult"
                  :key="i"
                >
                  <div class="row flex flex-between">
                    <el-checkbox :label="v" class="flex-4 flex">
                      <div class="flex flex-1">
                        <el-tooltip
                          :content="
                            v.attrType === 'barcode'
                              ? `条码：${v.barcode}`
                              : `货号：${v.goodsSn}`
                          "
                          placement="top"
                        >
                          <div class="flex flex-1 attrid">
                            {{
                              v.attrType === "barcode"
                                ? `条码：${v.barcode}`
                                : `货号：${v.goodsSn}`
                            }}
                          </div>
                        </el-tooltip>
                        <el-tooltip :content="v.attrValue" placement="top">
                          <div class="flex flex-3 flex-center attrid">
                            {{ v.attrValue || v.goodsName }}
                          </div>
                        </el-tooltip>
                      </div>
                    </el-checkbox>
                    <div class="flex flex-1 flex-center">
                      {{ v.goodsPackageNum }}
                    </div>
                    <div
                      class="flex-1 text-center"
                      @click="deleteCurrentCombinationGoods(v, i)"
                    >
                      <span
                        class="primary delete-icon hmicon icon-shanchu"
                      ></span>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div
              class="no-message text-center"
              v-show="!combinationResult.length"
            >
              请添加商品!
            </div>
          </div>
        </div>
      </div>
      <!-- 满送活动叠加 -->
      <div class="way" v-if="parentId === 'FullDeliveryOverlay'">
        <div class="flex flex-between item-center panel way-item">
          <div class="flex">
            <div class="mr20">
              叠加方式：
              <el-select
                style="width: 100px"
                v-model="overlayType"
                placeholder="请选择叠加方式"
                @change="overlayTypeChange"
              >
                <el-option label="阶梯" value="ladder"></el-option>
                <el-option label="循环" value="cycle"></el-option>
<!--                <el-option label="不叠加" value="no"></el-option>-->
              </el-select>
            </div>

            <div class="mr20">
              捆绑方式：
              <el-select
                style="width: 100px"
                v-model="selectType"
                placeholder="请选择捆绑方式"
              >
                <el-option label="混合" value="mix"></el-option>
                <el-option label="同品" value="same"></el-option>
              </el-select>
            </div>
            <div class="item mr20">
              每买满
              <el-input
                v-if="overlayType === 'no'"
                v-model="purchasesAmount"
                @input="filterGt0OrOverlay('purchasesAmount')"
                :disabled="Boolean(fullDeliveryGoods.length)"
                type="number"
              ></el-input>
              <el-input
                v-else
                v-model="purchasesAmount"
                @input="filterGt0OrOverlay('purchasesAmount')"
                type="number"
              ></el-input>
              <span v-if="childId === 'PriceDeliveryOverlay'">元</span>
              <span v-if="childId === 'NumDeliveryOverlay'">件</span>
            </div>
            <!-- 不循环 -->
            <template v-if="overlayType === 'no'">
              <!-- 同品模式 -->
              <div v-if="selectType === 'same'" class="flex">
                <div class="item mr20 flex item-center">送必选同品如下</div>
                <div class="item mr20 flex item-center">
                  送可选商品
                  <el-input
                    v-model="chooseDeliveryAmount"
                    size="small"
                  ></el-input
                  >件
                </div>
              </div>
              <!-- 混合模式 -->
              <div v-if="selectType === 'mix'" class="flex">
                <div class="item mr20 flex item-center">
                  送可选商品
                  <el-input
                    v-model="chooseDeliveryAmount"
                    @change="fullDeliveryResult = []"
                    @input="filterGt0('chooseDeliveryAmount')"
                    size="small"
                  ></el-input
                  >件
                </div>
                <div
                  class="item mr20 flex item-center"
                  v-if="fullDeliveryGoods.length <= 2"
                >
                  <div class="add-wrapper">
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addItem('fullDelivery')"
                    ></span>
                  </div>
                </div>
                <div
                  class="item mr20 flex item-center"
                  v-show="fullDeliveryGoods.length"
                >
                  <div>已选规则：</div>
                  <div
                    class="flex item-center mr20"
                    v-for="(v, i) in fullDeliveryGoods"
                    :key="i"
                  >
                    <span v-show="i === 0">送</span>
                    <span v-show="i > 0">加送</span>
                    <span class="primary">{{ v.selectLowerLimit }}</span
                    >件
                  </div>
                </div>
              </div>
            </template>
            <!-- 循环叠加 -->
            <template v-if="overlayType === 'cycle'">
              <!-- 同品模式 -->
              <div v-if="selectType === 'same'" class="flex">
                <div class="item  flex item-center">
                  送同品
                  <el-input v-model="sendNum" size="small"></el-input>组，
                </div>
                <div class="item  flex item-center">
                  每组必送同品
                  <el-input
                    type="number"
                    v-model="chooseDeliveryAmount"
                    size="small"
                  ></el-input
                  >件，
                </div>

                <div class="item mr20 flex item-center">
                  单笔最多送<el-input
                    v-model="maxCycleTimes"
                    size="small"
                  ></el-input
                  >组，超出部分不赠送
                  <!-- 送可选商品
                  <el-input v-model="chooseDeliveryAmount" size="small"></el-input
                  >件 -->
                </div>
              </div>
              <!-- 混合模式 -->
              <div v-if="selectType === 'mix'" class="flex">
                <div class="item  flex item-center">
                  选送如下商品
                  <el-input
                    v-model="sendNum"
                    @input="filterGt0('sendNum')"
                    size="small"
                  ></el-input
                  >组， 每组送可选商品
                  <el-input
                    v-model="chooseDeliveryAmount"
                    @input="filterGt0('chooseDeliveryAmount')"
                    size="small"
                  ></el-input
                  >件，
                </div>
                <div class="item mr20 flex item-center">
                  单笔最多送<el-input
                    v-model="maxCycleTimes"
                    size="small"
                  ></el-input
                  >组，超出部分不赠送
                </div>
                <!-- <div
                  class="item mr20 flex item-center"
                  v-if="fullDeliveryGoods.length < 1"
                >
                  <div class="add-wrapper">
                    <span
                      class="hmicon icon-hao pointer"
                      @click="addLadder"
                    ></span>
                  </div>
              </div> -->
                <!-- <div
                  class="item mr20 flex item-center"
                  v-show="fullDeliveryGoods.length"
                >
                  <div>已选规则：</div>
                  <div
                    class="flex item-center mr20"
                    v-for="(v, i) in fullDeliveryGoods"
                    :key="i"
                  >
                    <span v-show="i === 0">送</span>
                    <span v-show="i > 0">加送</span>
                    <span class="primary">{{ v.selectLowerLimit }}</span
                    >件
                  </div>
                </div> -->
              </div>
            </template>
            <!-- 阶梯叠加 -->
            <template v-if="overlayType === 'ladder'">
              <!-- 同品模式 -->
              <div v-if="selectType === 'same'" class="flex">
                <div class="item mr20 flex item-center">
                  必送同品
                  <el-input v-model="sendNum" size="small"></el-input>组
                </div>
              </div>
              <!-- 混合模式 -->
              <div v-if="selectType === 'mix'" class="flex">
                <div class="item mr20 flex item-center">
                  选送如下商品
                  <el-input
                    v-model="sendNum"
                    @input="filterGt0('sendNum')"
                    size="small"
                  ></el-input
                  >组
                </div>

                <!-- <div
                  class="item mr20 flex item-center"
                  v-show="fullDeliveryGoods.length"
                >
                  <div>已选规则：</div>
                  <div
                    class="flex item-center mr20"
                    v-for="(v, i) in fullDeliveryGoods"
                    :key="i"
                  >
                    <span v-show="i === 0">送</span>
                    <span v-show="i > 0">加送</span>
                    <span class="primary">{{ v.selectLowerLimit }}</span
                    >件
                  </div>
                </div> -->
              </div>
              <div
                class="item mr20 flex item-center"
                v-if="fullDeliveryGoods.length <= 2"
              >
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addLadder"
                  ></span>
                </div>
              </div>
              <div class="item mr20 flex item-center">
                {{ selectType === "same" ? "每组必送同品" : "每组选送" }}
                <el-input
                  type="number"
                  v-model="chooseDeliveryAmount"
                  size="small"
                ></el-input
                >件
              </div>
            </template>
          </div>
        </div>
        <!-- 阶梯叠加规则 -->
        <div
          class="way flex mb10"
          v-if="overlayType === 'ladder' && overlayRuleModelList.length"
        >
          <div>
            <div
              class="way-item flex item-center "
              :style="{
                marginBottom: i === overlayRuleModelList.length - 1 ? '0px' : ''
              }"
              v-for="(v, i) in overlayRuleModelList"
              :key="i"
            >
              买满
              <div style="width:80px" class="text-center">
                {{ v.purchasesAmount }}
              </div>
              <span v-if="childId === 'PriceDeliveryOverlay'">元</span>
              <span v-if="childId === 'NumDeliveryOverlay'">件</span>，
              <div>
                {{ selectType === "same" ? "必送同品" : "选送如下商品" }}
              </div>
              <div style="width:80px" class="text-center item">
                <el-input
                  style="width:80px"
                  v-model="v.sendNum"
                  @input="filterGt0OrOverlayList('sendNum', i)"
                  size="small"
                ></el-input>
              </div>

              {{ selectType === "same" ? "组" : "组" }}
              <div class="add-wrapper mr10">
                <span
                  class="hmicon icon-jianhao pointer"
                  @click="deleteLadder(i)"
                ></span>
              </div>
              <div></div>
            </div>
          </div>

          <div class="flex flex-center item-center">
            {{ selectType === "same" ? "每组必送同品" : "每组选送" }}
            {{ chooseDeliveryAmount }} 件
          </div>
        </div>

        <div class="mb20" v-show="selectType !== 'same'">
          赠送商品价格：
          <el-switch
            v-model="giftLimit"
            size="mini"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="yes"
            active-text="买高送低"
            inactive-text="不限"
            inactive-value="no"
          ></el-switch>
        </div>
        <div class="flex flex-between">
          <div>
            <el-button
              v-if="selectType !== 'same'"
              type="primary"
              @click="showTransfer"
              size="small"
              >添加商品</el-button
            >
            <el-button
              type="primary"
              :disabled="
                fullDeliveryGoods.length === 0
                  ? fullDeliveryGoods.length > 0
                  : fullDeliveryGoods[0].groupGoods.length > 0
              "
              @click="addGivingGoods"
              size="small"
              v-if="overlayType !== 'no' && selectType === 'mix'"
              >添加赠送商品</el-button
            >
          </div>

          <div>
            <el-input
              v-model="batchSelectUpperLimit"
              @input="filterGt0('batchSelectUpperLimit')"
              size="small "
              placeholder="批量设置赠送上限"
              style="width:300px"
              clearable
            >
              <el-button
                slot="append"
                icon="hmicon icon-jia"
                @click="batchUpperLimit"
              ></el-button>
            </el-input>

            <el-input
              class="ml10"
              size="small"
              v-model="keywords"
              @input="filterDeliveryGoods"
              placeholder="货号/商品关键字"
              suffix-icon="hmicon icon-search"
            ></el-input>
          </div>
        </div>
        <div
          class="flex flex-between mt20 p10"
          style="border:1px solid #EBEEF5;border-bottom:none"
        >
          <div></div>
          <div>促销商品</div>
          <div @click="deleteSelectedFullDelivery" class="delete pointer">
            <span class="delete-icon hmicon icon-shanchu"></span>
            删除
          </div>
        </div>

        <el-table
          stripe
          border
          :data="fullDeliveryResult"
          style="width: 100%"
          class=" mb20"
          id="table"
          @selection-change="handleCheckAllChange"
          size="small"
          max-height="300"
        >
          <el-table-column
            type="selection"
            :selectable="selectable"
          ></el-table-column>
          <!-- <el-table-column type="index" label="序号"></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="attrType"
            label="类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'brand'">
                添加品牌
              </div>
              <div v-if="scope.row.attrType === 'goods'">
                添加商品
              </div>
              <div v-if="scope.row.attrType === 'barcode'">
                添加sku商品
              </div>
              <div v-if="scope.row.attrType === 'category'">
                添加品类
              </div>
              <div v-if="scope.row.attrType === 'attribute'">
                添加属性
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="attrType"
            label="编号（只显示商品货号/条码）"
            width="200"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'goods'">
                货号:{{ scope.row.attrId }}
              </div>
              <div v-else-if="scope.row.attrType === 'barcode'">
                条码:{{ scope.row.attrId }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="attrValue"
            label="名称"
            width="500"
          ></el-table-column>
          <el-table-column
            prop="shopPrices"
            header-align="center"
            align="center"
            label="零售价"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useable"
            label="状态"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.useable === 'white'"
                class="select-type white"
                >白</span
              >
              <span
                v-if="scope.row.useable === 'black'"
                class="select-type black"
                >黑</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="selectUpperLimit"
            label="赠送上限"
          >
            <template slot-scope="scope">
              <el-input
                clearable
                style="width: 80px"
                v-model.trim="scope.row.selectUpperLimit"
                @input="filterInteger(scope.row.selectUpperLimit, scope.$index)"
                placeholder=""
                size="small"
                class="ipt"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                content="删除"
                placement="top"
                v-show="!scope.row.isSame"
              >
                <div
                  class="pointer mr10"
                  @click="
                    deleteCurrentDeliveryGoods(
                      scope.row.selectUpperLimit,
                      scope.$index
                    )
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="table" v-if="false">
          <div class="table-out-header flex flex-between">
            <div>
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <div>促销商品</div>
            <div @click="deleteSelectedFullDelivery" class="delete">
              <span class="delete-icon hmicon icon-shanchu"></span>
              删除
            </div>
          </div>
          <div class="table-header flex flex-between">
            <div class="flex-1 num">商品货号/条码</div>
            <div class="flex-3 text-center">商品名</div>
            <div class="flex-1 text-center">商品数量</div>
            <!-- <div class="flex-1 text-center">状态(<span class="danger">红色</span>可选|<span class="success">绿色</span>必选)</div> -->
            <!--  -->
            <div class="flex-1 text-center">赠送上限</div>
            <div class="flex-1 text-center">操作</div>
          </div>
          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="calcCondition-height: 500px;"
            >
              <el-checkbox-group
                v-model="checkedGoods"
                @change="handleCheckedGoodsChange"
              >
                <div
                  class="list-item"
                  v-for="(v, i) in fullDeliveryResult"
                  :key="i"
                >
                  <div class="row flex flex-between">
                    <el-checkbox
                      :label="v"
                      class="flex-4 flex item-center"
                      :disabled="v.isSame"
                    >
                      <div class="flex flex-1">
                        <el-tooltip
                          :content="
                            v.attrType === 'barcode'
                              ? `条码：${v.barcode}`
                              : `货号：${v.goodsSn}`
                          "
                          placement="top"
                        >
                          <div class="flex flex-1 attrid">
                            {{
                              v.attrType === "barcode"
                                ? `条码：${v.barcode}`
                                : `货号：${v.goodsSn}`
                            }}
                          </div>
                        </el-tooltip>
                        <el-tooltip
                          :content="v.goodsName || v.attrValue"
                          placement="top"
                        >
                          <div
                            style="width:400px"
                            class="text-overflow flex flex-3 text-center flex-center item-center"
                          >
                            {{ v.goodsName || v.attrValue }}
                          </div>
                        </el-tooltip>
                      </div>
                    </el-checkbox>
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      {{ v.goodsPackageNum }}
                    </div>
                    <!-- <div class="flex-1  text-center  flex flex-center item-center">
                      <el-switch v-model="v.isMustDelivery"
                                 size="mini"
                                 v-if="selectType === 'mix'"
                                 @change="swithcSelect"
                                 active-color="#13ce66"
                                 inactive-color="#ff4949"
                                 active-value="yes"
                                 inactive-value="no">
                      </el-switch>
                    </div>-->
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <div class="el-input el-input el-input--small">
                        <input
                          type="number"
                          class="el-input__inner"
                          style="width: 80px"
                          size="small"
                          @input="filterInteger(v.selectUpperLimit, i)"
                          v-model="v.selectUpperLimit"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <span
                        v-show="!v.isSame"
                        @click="deleteCurrentDeliveryGoods(v, i)"
                        class="primary delete-icon hmicon icon-shanchu"
                      ></span>
                    </div>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div
              class="no-message text-center"
              v-show="!fullDeliveryResult.length"
            >
              请添加商品!
            </div>
          </div>
        </div>
        <div v-if="fullDeliveryGoods.length">
          <div v-for="(v, i) in fullDeliveryGoods" :key="i">
            <div class="flex item-center">
              <div class="list-item mb20">
                <div class="flex mb20" v-if="overlayType === 'no'">
                  <span v-show="i === 0">送</span>
                  <span v-show="i > 0">加送</span>
                  <span class="primary">{{ v.selectLowerLimit }}</span
                  >件
                </div>
                <el-table
                  v-if="v.groupGoods.length"
                  :data="v.groupGoods"
                  size="small"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="货号"
                    width="150"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.attrId || scope.row.goodsSn }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名"
                    header-align="center"
                    align="center"
                    width="300"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.attrValue || scope.row.goodsName }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="shopPrices"
                    header-align="center"
                    align="center"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    prop="goodsPackageNum"
                    header-align="center"
                    align="center"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    prop="selectUpperLimit"
                    header-align="center"
                    align="center"
                    label="换购上限"
                  ></el-table-column>
                </el-table>
              </div>
              <div class="minus-wrapper" v-if="v.groupGoods.length">
                <span
                  class="hmicon icon-jianhao pointer"
                  @click="deleteItem('fullDeliveryGoods', i)"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 叠加赠送 -->
      <div class="way" v-if="parentId === 'SuperpositionGift'">
        <div class="flex flex-between item-center panel way-item">
          <div class="flex item-center">
            <div class="mr20">
              叠加
              <el-select
                style="width: 100px"
                v-model="pasSuperpositionGiftRuleLimitModel.giftMode"
                placeholder="请选择捆绑方式"
              >
                <el-option label="按数量" value="num"></el-option>
                <!-- <el-option label="按金额" value="amount"></el-option> -->
              </el-select>
            </div>
            <div class="item mr20">
              单件商品满
              <el-input
                v-model="pasSuperpositionGiftRuleLimitModel.purchasesAmount"
                @input="filterGt0OrFixed2('purchasesAmount')"
                type="number"
              ></el-input>
              <span v-if="childId === 'PriceDeliveryGift'">元</span>
              <span v-if="childId === 'NumDeliveryGift'">件</span>
              件循环赠送以下商品,并且用户无需选择
            </div>
            <div class="add-wrapper">
              <span
                class="hmicon icon-hao pointer"
                @click="addItem('pasSuperpositionGiftRuleGoodsModelListResult')"
                :disabled="pasSuperpositionGiftRuleGoodsModelListResult.length >= 20"
              ></span>
            </div>
          </div>
        </div>        
        <div class="flex flex-between">
          <!-- <el-button type="primary" @click="showTransfer" size="small"
            >添加商品</el-button
          > -->
          <el-button type="primary" @click="add('barcode', '添加sku商品')" size="small"
            >添加sku商品</el-button
          >
          <div>
            <el-input
              v-model="batchSelectUpperLimit"
              @input="filterGt0('batchSelectUpperLimit')"
              size="small "
              placeholder="批量设置赠送上限"
              style="width:300px"
              clearable
            >
              <el-button
                slot="append"
                icon="hmicon icon-jia"
                @click="batchUpperLimit"
              ></el-button>
            </el-input>

            <el-input
              class="ml10"
              size="small"
              v-model="keywords"
              @input="filterSuperpositionGift"
              placeholder="货号/商品关键字"
              suffix-icon="hmicon icon-search"
            ></el-input>
          </div>
        </div>
        <div
          class="flex flex-between mt20 p10"
          style="border:1px solid #EBEEF5;border-bottom:none"
        >
          <div></div>
          <div>促销商品</div>
          <div @click="deleteSelectedSuperpositionGift" class="delete pointer">
            <span class="delete-icon hmicon icon-shanchu"></span>
            删除
          </div>
        </div>

        <el-table
          stripe
          border
          :data="superpositionGiftResult"
          style="width: 100%"
          class=" mb20"
          id="table"
          @selection-change="handleCheckAllChange"
          size="small"
          max-height="300"
        >
          <el-table-column
            type="selection"
            :selectable="selectable"
          ></el-table-column>
          <!-- <el-table-column type="index" label="序号"></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="attrType"
            label="类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'brand'">
                添加品牌
              </div>
              <div v-if="scope.row.attrType === 'goods'">
                添加商品
              </div>
              <div v-if="scope.row.attrType === 'barcode'">
                添加sku商品
              </div>
              <div v-if="scope.row.attrType === 'category'">
                添加品类
              </div>
              <div v-if="scope.row.attrType === 'attribute'">
                添加属性
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="attrType"
            label="编号（只显示商品货号/条码）"
            width="200"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'goods'">
                货号:{{ scope.row.attrId }}
              </div>
              <div v-else-if="scope.row.attrType === 'barcode'">
                条码:{{ scope.row.attrId }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="attrValue"
            label="名称"
            width="500"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopPrices"
            label="零售价"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="useable"
            label="状态"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.useable === 'white'"
                class="select-type white"
                >白</span
              >
              <span
                v-if="scope.row.useable === 'black'"
                class="select-type black"
                >黑</span
              >
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="selectUpperNum"
            label="赠送数量"
          >
            <template slot-scope="scope">
              <el-input
                clearable
                style="width: 80px"
                v-model.trim="scope.row.selectUpperNum"
                @input="filterSelectUpperNumSuperpositionGift(scope.row.selectUpperNum, scope.$index)"
                placeholder=""
                size="small"
                class="ipt"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="selectUpperLimit"
            label="单笔订单赠送上限"
          >
            <template slot-scope="scope">
              <el-input
                clearable
                style="width: 80px"
                v-model.trim="scope.row.selectUpperLimit"
                @input="filterSelectUpperLimitSuperpositionGift(scope.row.selectUpperLimit, scope.$index)"
                placeholder=""
                size="small"
                class="ipt"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                content="删除"
                placement="top"
                v-show="!scope.row.isSame"
              >
                <div
                  class="pointer mr10"
                  @click="
                    deleteCurrentSuperpositionGif(
                      scope.row.selectUpperLimit,
                      scope.$index
                    )
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="pasSuperpositionGiftRuleGoodsModelListResult.length">          
            <div class="flex item-center">
              <div class="list-item mb20">                
                <el-table                  
                  :data="pasSuperpositionGiftRuleGoodsModelListResult"
                  size="small"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="条码"
                    width="150"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.attrId || scope.row.goodsSn }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名"
                    header-align="center"
                    align="center"
                    width="300"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.attrValue || scope.row.goodsName }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="shopPrices"
                    header-align="center"
                    align="center"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    prop="giftNum"
                    header-align="center"
                    align="center"
                    label="赠送数量"
                  ></el-table-column>
                  <el-table-column
                    prop="giftUpperLimitNum" 
                    header-align="center"
                    align="center"
                    label="单笔订单赠送上限"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                  >
                  <template slot-scope="scope">
                    <div class="minus-wrapper">
                      <span
                        class="hmicon icon-jianhao pointer"
                        @click="deleteItem('pasSuperpositionGiftRuleGoodsModelListResult', scope.$index)"
                      ></span>
                    </div>
                  </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
        </div>
      </div>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="back">上一步</el-button>
        <el-button type="primary" size="small" @click="submit('wait_commit')" v-if="parentId === 'SuperpositionGift'"
          >下一步</el-button
        >
        <el-button type="primary" size="small" @click="submit('wait_commit')" v-else
          >保存</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="showPreviewModal('wait_audit')"
          v-if="parentId !== 'SuperpositionGift'"
          >预览并提交</el-button
        >
      </div>
    </div>
    <el-dialog
      title="预览"
      :visible.sync="previewDiaogVisible"
      width="1200px"
      :close-on-click-modal="false"
      @close="previewDiaogVisible = false"
    >
      <div class="detail-container">
        <div class="activity mb20">
          <div class="caption">创建促销</div>
          <ul>
            <li class="flex">
              <div class="title">促销活动</div>
              <div class="content">
                {{ details.basicConfigInfo.promotionName }}
              </div>
            </li>
            <li class="flex" v-if="couponLevelList.length">
              <div class="title">促销层级</div>
              <div class="content">
                {{ pasLevelName }}
              </div>
            </li>
            <li class="flex">
              <div class="title">基础价&nbsp;&nbsp;&nbsp;</div>
              <div class="content">
                <span
                  v-show="
                    details.basicConfigInfo.assignPriceType === 'promotion'
                  "
                  >会员价</span
                >
                <span
                  v-show="details.basicConfigInfo.assignPriceType === 'retail'"
                  >零售价</span
                >
              </div>
            </li>
            <li
              class="flex"
              v-if="details.basicConfigInfo.runningTimeType === 'all'"
            >
              <div class="title">优惠时间</div>
              <div class="content primary" v-if="details.pasCalendars">
                {{ details.pasCalendars.promotionStartTime }}至{{
                  details.pasCalendars.promotionEndTime
                }}
              </div>
            </li>
            <li
              class="flex"
              v-if="details.basicConfigInfo.runningTimeType === 'special'"
            >
              <div class="title">优惠时间</div>
              <div class="content primary">
                {{ details.dateConfigInfo.promotionStartDate }}至{{
                  details.dateConfigInfo.promotionEndDate
                }}
              </div>
            </li>
            <li
              class="flex"
              v-if="details.basicConfigInfo.runningTimeType === 'special'"
            >
              <div class="title">特定时段</div>
              <div>
                <div
                  class="content primary"
                  v-if="details.dateConfigInfo.dateType === 'day'"
                >
                  <div>每{{ details.dateConfigInfo.dateValue }}天生效</div>
                </div>
                <div class="content primary">
                  <div
                    class="flex"
                    v-if="details.dateConfigInfo.dateType === 'week'"
                  >
                    每
                    <div
                      class="mr10"
                      v-for="(v, i) in details.dateConfigInfo.dateValues"
                      :key="i"
                    >
                      {{ "周" + v }}
                    </div>
                    生效
                  </div>
                  <div
                    class="flex"
                    v-if="details.dateConfigInfo.dateType === 'month'"
                  >
                    每月
                    <div
                      class="mr10"
                      v-for="(v, i) in details.dateConfigInfo.dateValues"
                      :key="i"
                    >
                      {{ v }}
                    </div>
                    日生效
                  </div>
                  <div v-for="(v, i) in details.dateConfigRange || []" :key="i">
                    {{ v.promotionStartTime }} 至 {{ v.promotionEndTime }}
                  </div>
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">参与门店</div>
              <div class="content">
                <div
                  v-if="
                    details.pasOutlets.length === 1 &&
                      details.pasOutlets[0].outletId === '0'
                  "
                >
                  全部门店
                </div>
              </div>
              <div class="content flex-1">
                <shop-picker
                  v-if="!(details.pasOutlets.length === 1 && details.pasOutlets[0].outletId === '0')"
                  readonly
                  :available-shops="storeShops"
                  :selected-shops="storeShops"
                  label=""
                />
              </div>
            </li>
            <li class="flex">
              <div class="title">销售渠道</div>
              <div class="content">
                <div v-for="(v, i) in details.platformModels || []" :key="i">
                  {{ v.platformName }}
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">会员群组</div>
              <div class="content">
                <div
                  v-if="
                    details.memberGroupList.length === 1 &&
                      details.memberGroupList[0].groupId === '0'
                  "
                >
                  全部会员群组
                </div>
              </div>
              <div class="content">
                <div v-for="(v, i) in details.groupListRes || []" :key="i">
                  {{ v.groupAppellation }}
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">促销标签</div>
              <div class="content flex">
                <el-tag v-for="(v, i) in details.pasLabels" :key="i">
                  {{ v.labelKey }}
                </el-tag>
              </div>
            </li>
          </ul>
        </div>
        <div
          class="goods mb20"
          v-if="details.pasGoods && details.pasGoods.length"
        >
          <div class="caption">选择商品</div>
          <el-table
            stripe
            :data="details.pasGoods || []"
            style="width: 100%"
            id="table"
            border
            size="small"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrType"
              label="类型"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.attrType === 'brand'">
                  添加品牌
                </div>
                <div v-if="scope.row.attrType === 'goods'">
                  添加商品
                </div>
                <div v-if="scope.row.attrType === 'barcode'">
                  添加sku商品
                </div>
                <div v-if="scope.row.attrType === 'category'">
                  添加品类
                </div>
                <div v-if="scope.row.attrType === 'attribute'">
                  添加属性
                </div>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="attrId"
              label="编号（只显示商品货号/条码）"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.attrType === 'goods'">
                  货号:{{ scope.row.attrId }}
                </div>
                <div v-else-if="scope.row.attrType === 'barcode'">
                  条码:{{ scope.row.attrId }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrValue"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="showPrice"
              label="零售价"
            ></el-table-column>
            <el-table-column header-align="center" align="center" label="状态">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.useable === 'white'"
                  class="select-type white"
                  >白</span
                >
                <span
                  v-if="scope.row.useable === 'black'"
                  class="select-type black"
                  >黑</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="rule mb20">
          <div class="caption">创建规则</div>
          <ul>
            <li class="flex">
              <div class="title" style="width: 56px">促销类型</div>
              <!-- 满减 -->
              <div
                class="content"
                v-if="
                  details.fullReductionRule && details.fullReductionRule.length
                "
              >
                <div
                  v-for="(v, i) in details.fullReductionRule"
                  :key="i"
                  class="flex"
                >
                  <div class="mr10">
                    每买满
                    <span class="primary">{{ v.calcCondition }}</span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'NumReduction'
                      "
                      >件</span
                    >
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'PriceReduction'
                      "
                      >元</span
                    >
                  </div>
                  <div class="mr10">
                    减
                    <span class="primary">{{ v.discountResult }}</span
                    >元
                  </div>
                  <div>
                    最多循环
                    <span class="primary">{{ v.cyclesTimes }}</span
                    >次
                  </div>
                </div>
              </div>
              <!-- 满折 -->
              <div
                class="content"
                v-if="
                  details.fullDiscountRule && details.fullDiscountRule.length
                "
              >
                <div>
                  <span v-show="discountMode === 'floorPriceDiscount'"
                    >最低价打折</span
                  >
                  <span v-show="discountMode === 'fullPriceDiscount'"
                    >整单打折</span
                  >
                </div>
                <div v-for="(v, i) in details.fullDiscountRule" :key="i">
                  <div class="mr10">
                    每买满
                    <span class="primary">{{ v.purchasesAmount }}</span>
                    <span
                      class="mr10"
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'NumDiscount'
                      "
                      >件</span
                    >
                    <span
                      class="mr10"
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'PriceDiscount'
                      "
                      >元</span
                    >
                    <span v-show="discountMode === 'floorPriceDiscount'"
                      >最低价商品</span
                    >打 <span class="primary">{{ v.discountRatio }}</span
                    >折
                  </div>
                </div>
              </div>
              <!-- 满送 -->
              <div class="content flex-1" v-if="details.fullDeliveryRule">
                <div class="flex">
                  <div class="mr10">
                    捆绑方式
                    <span class="primary">
                      {{
                        details.fullDeliveryRule.selectType === "mix"
                          ? "混合"
                          : "同品"
                      }}
                    </span>
                  </div>
                  <div
                    class="mr10"
                    v-if="details.fullDeliveryRule.selectType !== 'same'"
                  >
                    赠送商品价格
                    <span
                      class="primary"
                      v-show="details.fullDeliveryRule.giftLimit === 'yes'"
                      >买高送低</span
                    >
                    <span
                      class="primary"
                      v-show="details.fullDeliveryRule.giftLimit === 'no'"
                      >不限</span
                    >
                  </div>
                  <!-- 赠送同品模式 -->
                  <div class="mr10">
                    每买满
                    <span class="primary">
                      {{ details.fullDeliveryRule.purchasesAmount }}
                    </span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'NumDelivery'
                      "
                      >件</span
                    >
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'PriceDelivery'
                      "
                      >元</span
                    >
                  </div>
                  <div
                    class="flex"
                    v-if="details.fullDeliveryRule.selectType === 'same'"
                  >
                    <div class="mr10">
                      <!-- 送必选商品<span class="primary">{{details.fullDeliveryRule.mustDeliveryAmount}}</span>件 -->
                      送必选同品如下
                    </div>
                    <!-- <div>
                      送同品
                      <span class="primary">{{
                        details.fullDeliveryRule.chooseDeliveryAmount
                      }}</span
                      >件
                    </div> -->
                  </div>
                </div>
                <!-- 赠送同品模式 -->
                <div v-if="details.fullDeliveryRule.selectType === 'same'">
                  <!-- 防止被缓存加上v-if  -->
                  <el-table
                    stripe
                    v-if="previewDiaogVisible"
                    :data="details.deleveryGoods"
                    style="width: 100%"
                    id="table"
                    border
                    size="small"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      show-overflow-tooltip
                      label="商品货号/条码"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.attrType === 'goods'">
                          货号:{{ scope.row.attrId }}
                        </div>
                        <div v-else-if="scope.row.attrType === 'barcode'">
                          条码:{{ scope.row.attrId }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsName"
                      label="商品名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="shopPrices"
                      label="零售价"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPackageNum"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="selectUpperLimit"
                      label="赠送上限"
                    ></el-table-column>
                  </el-table>
                </div>
                <!-- 赠送混合模式 -->
                <div v-if="details.fullDeliveryRule.selectType === 'mix'">
                  <div v-for="(v, i) in details.fullDeliveryGoods" :key="i">
                    <div class="mb20 flex">
                      <div>
                        <span v-if="i > 0">加</span>送可选商品
                        <span class="primary">{{ v.selectLowerLimit }}</span
                        >件
                      </div>
                    </div>
                    <el-table
                      stripe
                      :data="v.groupGoods"
                      style="width: 100%"
                      id="table"
                      border
                      size="small"
                    >
                      <el-table-column
                        type="index"
                        width="50"
                        label="序号"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsSn"
                        label="商品货号"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsName"
                        label="商品名称"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="shopPrices"
                        label="零售价"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsPackageNum"
                        label="商品数量"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="selectUpperLimit"
                        label="赠送上限"
                      ></el-table-column>
                      <!-- <el-table-column header-align="center"
                                    align="center"
                                    prop="isMustDelivery"
                                    label="状态">
                      <template slot-scope="scope">
                        <span class="success"
                              v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                        <span class="danger"
                              v-show="scope.row.isMustDelivery === 'no'">可选</span>
                      </template>
                      </el-table-column>-->
                    </el-table>
                  </div>
                </div>
              </div>
              <!-- 满送叠加 -->
              <div
                class="content flex-1"
                v-if="details.fullDeliveryOverlayRuleModel"
              >
                <div class="flex">
                  <div class="mr10">
                    叠加方式
                    <span
                      class="primary"
                      v-if="
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'ladder'
                      "
                    >
                      阶梯
                    </span>
                    <span
                      class="primary"
                      v-else-if="
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'cycle'
                      "
                    >
                      循环
                    </span>
                    <span
                      class="primary"
                      v-if="
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'no'
                      "
                    >
                      不叠加
                    </span>
                  </div>
                  <div class="mr10">
                    捆绑方式
                    <span class="primary">
                      {{
                        details.fullDeliveryOverlayRuleModel.selectType ===
                        "mix"
                          ? "混合"
                          : "同品"
                      }}
                    </span>
                  </div>
                  <div
                    class="mr10"
                    v-if="
                      details.fullDeliveryOverlayRuleModel.selectType !== 'same'
                    "
                  >
                    赠送商品价格
                    <span
                      class="primary"
                      v-show="
                        details.fullDeliveryOverlayRuleModel.giftLimit === 'yes'
                      "
                      >买高送低</span
                    >
                    <span
                      class="primary"
                      v-show="
                        details.fullDeliveryOverlayRuleModel.giftLimit === 'no'
                      "
                      >不限</span
                    >
                  </div>
                  <!-- 赠送同品模式 -->
                  <div
                    class="mr10"
                    v-if="
                      details.fullDeliveryOverlayRuleModel.overlayType !==
                        'ladder'
                    "
                  >
                    每买满
                    <span class="primary">
                      {{
                        details.fullDeliveryOverlayRuleModel
                          .overlayRuleModelList[0].purchasesAmount
                      }}
                    </span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'NumDeliveryOverlay'
                      "
                      >件</span
                    >
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'PriceDeliveryOverlay'
                      "
                      >元</span
                    >
                  </div>
                  <div
                    class="flex"
                    v-if="
                      details.fullDeliveryOverlayRuleModel.selectType ===
                        'same' &&
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'no'
                    "
                  >
                    <div class="mr10">
                      <!-- 送必选商品<span class="primary">{{details.fullDeliveryRule.mustDeliveryAmount}}</span>件 -->
                      送必选同品如下
                    </div>
                    <!-- <div>
                      送同品
                      <span class="primary">{{
                        details.fullDeliveryOverlayRuleModel
                          .overlayRuleModelList[0].sendNum
                      }}</span
                      >件
                    </div> -->
                  </div>
                  <div
                    class="flex"
                    v-else-if="
                      details.fullDeliveryOverlayRuleModel.selectType ===
                        'same' &&
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'cycle'
                    "
                  >
                    <div class="mr10">
                      送同品
                      <span class="primary">{{
                        details.fullDeliveryOverlayRuleModel
                          .overlayRuleModelList[0].sendNum
                      }}</span
                      >组,
                    </div>
                    <div class="mr10">
                      每组必送同品
                      <span class="primary">{{
                        details.fullDeliveryGoods[0].selectLowerLimit
                      }}</span
                      >件,
                    </div>
                    <div>
                      单笔最多送
                      <span class="primary">{{
                        details.fullDeliveryOverlayRuleModel
                          .overlayRuleModelList[0].maxCycleTimes
                      }}</span
                      >件,
                    </div>
                    超出部分不赠送
                  </div>
                  <div
                    class="flex"
                    v-else-if="
                      details.fullDeliveryOverlayRuleModel.selectType ===
                        'mix' &&
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'cycle'
                    "
                  >
                    <div class="mr10">
                      送如下商品
                      <span class="primary">{{
                        details.fullDeliveryOverlayRuleModel
                          .overlayRuleModelList[0].sendNum
                      }}</span
                      >组, 每组送可选商品
                      <span class="primary">{{
                        details.fullDeliveryGoods[0].selectLowerLimit
                      }}</span
                      >件，
                    </div>
                    <div>
                      单笔最多送
                      <span class="primary">{{
                        details.fullDeliveryOverlayRuleModel
                          .overlayRuleModelList[0].maxCycleTimes
                      }}</span
                      >组,
                    </div>
                    超出部分不赠送
                  </div>
                </div>
                <!-- 阶梯叠加规则 -->
                <div
                  class="way flex"
                  v-if="
                    overlayType === 'ladder' &&
                      details.fullDeliveryOverlayRuleModel.overlayRuleModelList
                        .length
                  "
                >
                  <div>
                    <div
                      class="flex item-center"
                      :class="{
                        'way-item':
                          i <
                          details.fullDeliveryOverlayRuleModel
                            .overlayRuleModelList.length -
                            1
                      }"
                      v-for="(v, i) in details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList"
                      :key="i"
                    >
                      买满
                      <div style="width:80px" class="text-center">
                        {{ v.purchasesAmount }}
                      </div>
                      <span v-if="childId === 'PriceDeliveryOverlay'">元</span>
                      <span v-if="childId === 'NumDeliveryOverlay'">件</span>，
                      <div>
                        {{
                          selectType === "same" ? "必送同品" : "选送如下商品"
                        }}
                      </div>
                      <div style="width:80px" class="text-center">
                        {{ v.sendNum }}
                      </div>
                      组
                    </div>
                  </div>
                  <div class="flex flex-center item-center ml10">
                    {{ selectType === "same" ? "每组必送同品" : "每组选送" }}
                    {{ chooseDeliveryAmount }} 件
                  </div>
                </div>
                <!-- 赠送同品模式 -->
                <div
                  v-if="
                    details.fullDeliveryOverlayRuleModel.selectType === 'same'
                  "
                >
                  <!-- 防止被缓存加上v-if  -->
                  <el-table
                    stripe
                    v-if="previewDiaogVisible"
                    :data="details.deleveryGoods"
                    style="width: 100%"
                    id="table"
                    border
                    size="small"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="attrType"
                      label="类型"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.attrType === 'brand'">
                          品牌
                        </div>
                        <div v-if="scope.row.attrType === 'goods'">
                          商品
                        </div>
                        <div v-if="scope.row.attrType === 'barcode'">
                          sku商品
                        </div>
                        <div v-if="scope.row.attrType === 'category'">
                          品类
                        </div>
                        <div v-if="scope.row.attrType === 'attribute'">
                          属性
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      show-overflow-tooltip
                      label="编号（只显示商品货号/条码）"
                      width="200"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.attrType === 'goods'">
                          货号:{{ scope.row.attrId }}
                        </div>
                        <div v-else-if="scope.row.attrType === 'barcode'">
                          条码:{{ scope.row.attrId }}
                        </div>
                      </template>
                      <!-- <template slot-scope="scope">
                        {{scope.row.attrType==='barcode'?`条码：${scope.row.barcode}`:`货号：${scope.row.goodsSn}`}}
                      </template> -->
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsName"
                      label="名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="shopPrices"
                      label="零售价"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPackageNum"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="selectUpperLimit"
                      label="赠送上限"
                    ></el-table-column>
                  </el-table>
                </div>
                <!-- 赠送混合模式 -->
                <div
                  v-if="
                    details.fullDeliveryOverlayRuleModel.selectType === 'mix'
                  "
                >
                  <div v-for="(v, i) in details.fullDeliveryGoods" :key="i">
                    <div
                      class="mb20 flex"
                      v-if="
                        details.fullDeliveryOverlayRuleModel.overlayType ===
                          'no'
                      "
                    >
                      <div>
                        <span v-if="i > 0">加</span>送可选商品
                        <span class="primary">{{ v.selectLowerLimit }}</span
                        >件
                      </div>
                    </div>
                    <el-table
                      stripe
                      :data="v.groupGoods"
                      style="width: 100%"
                      id="table"
                      border
                      size="small"
                    >
                      <el-table-column
                        type="index"
                        width="50"
                        label="序号"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsSn"
                        label="商品货号"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsName"
                        label="商品名称"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="shopPrices"
                        label="零售价"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="goodsPackageNum"
                        label="商品数量"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="selectUpperLimit"
                        label="赠送上限"
                      ></el-table-column>
                      <!-- <el-table-column header-align="center"
                                    align="center"
                                    prop="isMustDelivery"
                                    label="状态">
                      <template slot-scope="scope">
                        <span class="success"
                              v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                        <span class="danger"
                              v-show="scope.row.isMustDelivery === 'no'">可选</span>
                      </template>
                      </el-table-column>-->
                    </el-table>
                  </div>
                </div>
              </div>
              <!-- 加价购 -->
              <div class="content flex-1" v-if="details.increasePurchaseRules">
                <div
                  class="mb20"
                  v-for="(v, i) in details.increasePurchaseRules"
                  :key="i"
                >
                  <div class="flex mb20">
                    <div class="item mr20">
                      每买满
                      <span class="primary">{{ v.purchasesAmount }}</span>
                      <span
                        v-if="
                          details.basicConfigInfo.promotionCode.split(
                            '-'
                          )[1] === 'NumIncrease'
                        "
                        >件</span
                      >
                      <span
                        v-if="
                          details.basicConfigInfo.promotionCode.split(
                            '-'
                          )[1] === 'PriceIncrease'
                        "
                        >元</span
                      >
                    </div>
                    <div class="item mr20">
                      加
                      <span class="primary">{{ v.markupFee }}</span
                      >元
                    </div>
                    <div class="item mr20 flex item-center">
                      换购
                      <span class="primary">{{
                        v.exchangePurchasesUpperAmount
                      }}</span
                      >件
                    </div>
                  </div>
                  <!-- 加价购赠送商品 -->
                  <el-table
                    :data="v.purchaseGoodsList"
                    size="mini"
                    stripe
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      prop="goodsSn"
                      header-align="center"
                      align="center"
                      label="货号"
                    ></el-table-column>
                    <el-table-column
                      prop="goodsName"
                      header-align="center"
                      align="center"
                      label="商品名"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="shopPrices"
                      label="零售价"
                    ></el-table-column>
                    <el-table-column
                      prop="goodsPackageNum"
                      header-align="center"
                      align="center"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      prop="selectUpperLimit"
                      header-align="center"
                      align="center"
                      label="换购上限"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- 打包价 -->
              <div class="content flex-1" v-if="details.combinationPriceGoods">
                <div
                  class="flex mb20"
                  v-for="(v, i) in details.combinationPriceRules"
                  :key="i"
                >
                  <div class="item mr20">
                    每买满
                    <span class="primary">{{ v.purchasesAmount }}</span
                    >件
                  </div>
                  <div class="item mr20">
                    打包价
                    <span class="primary">{{ v.combinationPrice }}</span
                    >元
                  </div>
                </div>
                <el-table
                  :data="details.combinationPriceGoods"
                  size="mini"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    width="200px"
                    show-overflow-tooltip
                    label="商品货号/条码"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.attrType === "barcode"
                          ? `条码：${scope.row.barcode}`
                          : `货号：${scope.row.goodsSn}`
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="goodsName"
                    header-align="center"
                    align="center"
                    label="商品名"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="shopPrices"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    prop="goodsPackageNum"
                    header-align="center"
                    align="center"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    prop="selectUpperLimit"
                    header-align="center"
                    align="center"
                    label="换购上限"
                  ></el-table-column>
                </el-table>
              </div>
              <!-- 特价 -->
              <div class="content flex-1" v-if="details.listHot">
                <el-table
                  :data="details.listHot"
                  size="mini"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    prop="goodsSn"
                    width="200px"
                    show-overflow-tooltip
                    label="商品货号/条码"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.attrType === "barcode"
                          ? `条码：${scope.row.barcode}`
                          : `货号：${scope.row.goodsSn}`
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="goodsName"
                    header-align="center"
                    align="center"
                    label="商品名"
                  ></el-table-column>
                  <el-table-column
                    prop="goodsPackageNum"
                    header-align="center"
                    align="center"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    prop="shopPrices"
                    header-align="center"
                    align="center"
                    label="商品价格"
                  ></el-table-column>
                  <el-table-column
                    prop="totalStockNum"
                    header-align="center"
                    align="center"
                    label="促销库存"
                  ></el-table-column>
                  <el-table-column
                    prop="purchasesUpperLimit"
                    header-align="center"
                    align="center"
                    label="单人限购"
                  ></el-table-column>
                  <el-table-column
                    prop="discountRatio"
                    header-align="center"
                    align="center"
                    label="折扣比率"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.discountRatio }}折
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="discountPrice"
                    header-align="center"
                    align="center"
                    label="折扣金额"
                  ></el-table-column>
                </el-table>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="submit('wait_audit')"
          >确 定</el-button
        >
        <el-button size="small" @click="previewDiaogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <hm-transfer
        ref="ruleTransfer"
        onlySelectGoods
        :showAttribute="parentId === 'FullDelivery'"
        :showMustDelivery="showMustDelivery"
        :leftOption="leftRules"
        :showBarcode="showBarcode"
      ></hm-transfer>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="saveSelectedGoods" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量设置"
      :close-on-click-modal="false"
      :visible.sync="batchDialogVisible"
      width="600px"
    >
      <el-form label-width="80px">
        <el-form-item label="促销库存">
          <el-input
            size="small"
            type="number"
            placeholder="请输入促销库存"
            @input="filterIntegerFunc('totalStockNum')"
            v-model="totalStockNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="单人限购">
          <el-input
            size="small"
            type="number"
            placeholder="请输入单人限购"
            @input="filterGt0('purchasesUpperLimit')"
            v-model="purchasesUpperLimit"
          ></el-input>
        </el-form-item>
        <el-form-item label="折扣比率">
          <el-input
            size="small"
            type="number"
            placeholder="请输入折扣比率"
            @input="filterGt0OrFixed2('discountRatio')"
            v-model="discountRatio"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="batchSetting" size="small" type="primary"
          >保存</el-button
        >
        <el-button
          @click="batchDialogVisible = false"
          size="small"
          type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleSku"
      width="1200px"
    >
      <div v-if="type === 'barcode'">
        <div class="table-panel flex flex-end">
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.keywords"
            size="small"
            placeholder="请输入货号,条码,品牌"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="searchAdd"
            >查询</el-button
          >
        </div>
        <el-table
          stripe
          border
          ref="table"
          :data="addList"
          style="width: 100%"
          id="table"
          size="small"
          @selection-change="getCheckedAdd"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAdd - 1) * pageSizeAdd + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
            column-key="spuName"
          >
            <template slot-scope="scope">
              {{ scope.row.spuName }}
            </template>
          </el-table-column>    
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌"
            column-key="brandName"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>      
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品货号"
            column-key="goodsSn"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsSn }}
            </template>
          </el-table-column>    
          <el-table-column
            header-align="center"
            align="center"
            prop="specBarcode"
            label="商品条码"
            column-key="specBarcode"
          >
            <template slot-scope="scope">
              {{ scope.row.specBarcode }}
            </template>
          </el-table-column>
           <el-table-column
            header-align="center"
            align="center"
            prop="shopPrices"
            label="商品售价"
            column-key="shopPrices"
          >
            <template slot-scope="scope">
              {{ scope.row.shopPrices }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalAdd"
          @current-change="pagingAdd"
          @size-change="handleSizeChangeAdd"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes,  prev, pager, next, jumper"
          :current-page="currentPageAdd"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">        
        <el-button @click="saveSelected" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisibleSku = false" size="small">取消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import HmTransfer from "@/components/HmTransfer";
import { ShopPicker } from "@/components/shop-picker";
import XLSX from "xlsx";
import {
  getCookie,
  queryActivityCategory,
  setCookie,
  removeCookie,
  arrayUnique2,
  ToFixed
} from "@/utils/utils";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  data() {
    return {
      showBarcode: true,
      couponLevelList: [],
      pasLevelName: "",
      batchSelectUpperLimit: "",
      giftLimit: "yes",
      fullDeliveryGoods: [],
      goodsPackageNumFlag: true,
      listHot: [],
      selectedListHot: [],
      combinationResult: [],
      selectedCombination: [],
      combinationPriceRules: [],
      combinationPrice: "",
      increasePurchaseResult: [],
      selectedIncreasePurchase: [],
      markupFee: "",
      exchangePurchasesUpperAmount: "",
      increasePurchaseRules: [],
      selectType: "mix",
      mustDeliveryAmount: "",
      sendNum: "",
      maxCycleTimes: "",
      chooseDeliveryAmount: "",
      purchasesAmount: "",
      disabledFirst: false,
      currentStep: 4,
      childTypeName: "",
      parentId: "",
      childId: "",
      showMustDelivery: false,
      checkedGoods: [],
      leftRules: [],
      checkAll: false,
      totalStockNum: "",
      purchasesUpperLimit: "",
      discountRatio: "",
      batchDialogVisible: false,
      isIndeterminate: false,
      fullDeliveryResult: [],
      superpositionGiftResult: [],
      selectedSuperpositionGift: [],
      discountMode: "fullPriceDiscount",
      selectedFullDeliveryGoods: [],
      keywords: "",
      dialogVisible: false,
      type: 4,
      calcCondition: "",
      discountResult: "",
      cyclesTimes: 0,
      undiscountRatio: "",
      previewDiaogVisible: false,
      fullDiscountRule: [],
      isCopy: false,
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: [],
        memberGroupList: [],
        platformModels: []
      },
      steps: [
        {
          link: "SelectActivity",
          name: "选择促销类型"
        },
        {
          link: "CreatActivity",
          name: "创建促销"
        },
        {
          link: "GoodsManagement",
          name: "管理促销商品"
        },
        {
          link: "CreatGoodsRule",
          name: "创建规则"
        }
      ],
      fullReductionRule: [],
      overlayType: "ladder",
      overlayRuleModelList: [],
      showUpperNum: "999999",
      pasSuperpositionGiftRuleLimitModel:{
        giftMode: "num",
        purchasesAmount: "",
        cyclesTimes: 9999,
        seqNum: 0,
      },
      pasSuperpositionGiftRuleGoodsModelListResult:[],
      dialogVisibleSku: false,
      addList: [],
      checkedRow: [],
      currentPageAdd: 1,
      pageSizeAdd: 10,
      totalAdd: 0,
      title: "",
      searchCondition: {
        queryType: "",
        keyWords: "",
      },
    };
  },
  created() {
    const { type, subType } = this.$route.query;
    this.disabledFirst = type === "edit";
    this.isCopy = subType === "copy";
  },
  mounted() {
    const STEP = getCookie({ key: "STEP" });
    this.parentId = STEP.step1.parentId;
    this.childId = STEP.step1.childId;
    console.log("this.childId:",this.childId);
    this.childTypeName = queryActivityCategory({
      parentId: this.parentId,
      childId: this.childId
    }).childTypeName;
    if (
      this.parentId === "SpecialPrice" ||
      this.parentId === "CombinationPrice"
    ) {
      this.steps.splice(2, 1);
      this.currentStep = 3;
    }
    if(this.parentId==='SuperpositionGift'){
      this.steps.splice(2, 1);
      this.steps.push({
        link: "ConnectedActivities",
        name: "关联活动"
      })
      this.currentStep = 3;
    }
    this.cookieEcho(STEP.step4);
  },
  beforeDestroy() {
    this.saveCookie();
  },
  watch: {
    discountMode(val) {
      if (val === "floorPriceDiscount") {
        this.fullDiscountRule = [];
      }
    },
    selectType(val) {
      const STEP = getCookie({ key: "STEP" });

      if (val === "same") {
        this.mustDeliveryAmount = 0;
        this.selectedFullDeliveryGoods = STEP.step3;

        // this.selectedFullDeliveryGoods = STEP.step3.filter(
        //   v => v.attrType === "goods" || v.attrType === "barcode"
        // );

        this.selectedFullDeliveryGoods.forEach(v => {
          v.selectUpperLimit = 1;
          v.isSame = true;
          v.isMustDelivery = "yes";
          this.mustDeliveryAmount += v.goodsPackageNum;
        });

        this.fullDeliveryResult = this.selectedFullDeliveryGoods;
        this.fullDeliveryGoods = [];
      } else {
        this.selectedFullDeliveryGoods = [];
        this.fullDeliveryResult = this.selectedFullDeliveryGoods;
      }
      this.overlayRuleModelList = [];
    }
  },
  computed: {
    // 参与门店：storeList 映射为 ShopPicker 需要的 {shopId, shopName}
    storeShops() {
      return (this.details.storeList || []).map(item => ({
        shopId: item.shopId || item.id,
        shopName: item.name || item.shopName
      }));
    }
  },
  methods: {
    selectable(row) {
      if (row.isSame) {
        return false;
      } else {
        return true;
      }
    },
    async queryCouponLevelList() {
      let params = {
        dictCode: "pas_level"
      };
      const { result } = await this.$store.dispatch("queryPasList", params);
      if (result) {
        const { sysDictItem } = result;

        this.couponLevelList = sysDictItem;

        this.pasLevelName = this.couponLevelList.find(
          o => o.itemValue == this.details.basicConfigInfo.pasLevel
        ).itemText;
      }
    },
    batchUpperLimit() {
      if (this.batchSelectUpperLimit !== "") {
        if( this.parentId === 'SuperpositionGift' ){
          this.superpositionGiftResult.forEach(v => {
            v.selectUpperLimit = this.batchSelectUpperLimit;
          });
        }else{
          this.fullDeliveryResult.forEach(v => {
            v.selectUpperLimit = this.batchSelectUpperLimit;
          });
        }
        
        this.$message({
          type: "success",
          message: "操作成功！"
        });
        this.batchSelectUpperLimit = "";
      }
    },
    filter(v, prop, type) {
      // v[prop] = v[prop].replace(/^(0+)/, ""); //过滤0开头
      v[prop] = v[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      v[prop] = v[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      v[prop] = v[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (type === "points") {
        v[prop] = v[prop].replace(/\./g, ""); //仅保留数字"
      } else if (type === "minus") {
        // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
        // this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        // this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        // this[prop] = this[prop]
        //   .replace(".", "$#*")
        //   .replace(/\./g, "")
        //   .replace("$#*", "."); //去除其他"."
        // this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
        // if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //   //首位是0的话去掉
        //   this[prop] = parseFloat(this[prop]);
        // }
        v[prop] = v[prop].replace(/\-/g, ""); //仅保留数字"
      } else {
        v[prop] = v[prop].replace(/[^\d]/g, ""); //仅保留数字"
      }
      this.$set(v, prop, v[prop]);
    },
    overlayTypeChange(val) {
      if (val != "ladder") {
        this.overlayRuleModelList = [];
      } else if (val === "ladder") {
        if (this.selectType === "mix") {
          this.fullDeliveryGoods = [];
          this.fullDeliveryResult = [];
        }
      }
    },
    deleteLadder(i) {
      this.overlayRuleModelList.splice(i, 1);
    },
    addGivingGoods() {
      if (!this.fullDeliveryResult.length) {
        this.$message({
          type: "error",
          message: "请添加商品"
        });
      } else {
        this.checkedGoods;

        if (this.selectType === "mix") {
          if (this.checkedGoods.length) {
            const groupFlag = this.fullDeliveryGoods.length
              ? this.fullDeliveryGoods.length
              : 0;

            if (!this.fullDeliveryGoods.length) {
              this.fullDeliveryGoods.push({
                groupGoods: this.checkedGoods,
                giftLimit: this.giftLimit,
                groupFlag,
                selectLowerLimit: +this.chooseDeliveryAmount
              });
            } else {
              this.$set(this.fullDeliveryGoods, 0, {
                groupGoods: this.checkedGoods,
                giftLimit: this.giftLimit,
                groupFlag,
                selectLowerLimit: +this.chooseDeliveryAmount
              });
              // this.fullDeliveryGoods[0] = {
              //   groupGoods: this.checkedGoods,
              //   giftLimit: this.giftLimit,
              //   groupFlag,
              //   selectLowerLimit: +this.chooseDeliveryAmount
              // };
            }
          } else {
            this.$message({
              type: "error",
              message: "请先选择要赠送的商品！"
            });
          }
        }
      }
    },
    addLadder() {
      // let totalLimit = 0;
      // this.increasePurchaseResult.map(v => {
      //   totalLimit += v.selectUpperLimit;
      // });
      if (!this.purchasesAmount) {
        this.$message({
          type: "error",
          message: "请输入购买门槛"
        });
      } else if (!+this.sendNum) {
        this.$message({
          type: "error",
          message: "请输入可送商品数量"
        });
      }
      // else if (!this.fullDeliveryResult.length) {
      //   this.$message({
      //     type: "error",
      //     message: "请添加商品"
      //   });
      // }
      else {
        if (this.overlayType === "ladder") {
          let flag = true;
          this.overlayRuleModelList.forEach(v => {
            if (v.purchasesAmount == this.purchasesAmount) {
              // v.sendNum = this.sendNum;
              flag = false;
            }
          });
          if (flag) {
            this.overlayRuleModelList.push({
              purchasesAmount: this.purchasesAmount,
              sendNum: this.sendNum
            });
          } else {
            this.$message({
              type: "error",
              message: "已存在同类型规则"
            });
          }

          this.purchasesAmount = "";
          this.sendNum = "";
        }

        // if (this.overlayType === "no") {
        //   const groupFlag = this.fullDeliveryGoods.length
        //     ? this.fullDeliveryGoods.length
        //     : 0;
        //   this.fullDeliveryGoods.push({
        //     groupGoods: this.fullDeliveryResult,
        //     giftLimit: this.giftLimit,
        //     groupFlag,
        //     selectLowerLimit: +this.chooseDeliveryAmount
        //   });
        // } else {
        //   if (this.selectType === "mix") {
        //     const groupFlag = this.fullDeliveryGoods.length
        //       ? this.fullDeliveryGoods.length
        //       : 0;
        //     if (!this.fullDeliveryGoods.length) {
        //       this.fullDeliveryGoods.push({
        //         groupGoods: this.fullDeliveryResult,
        //         giftLimit: this.giftLimit,
        //         groupFlag,
        //         selectLowerLimit: +this.chooseDeliveryAmount
        //       });
        //     }
        //   }
        // }
      }

      // else if (!this.fullDeliveryResult.length) {
      //   this.$message({
      //     type: "error",
      //     message: "请添加商品"
      //   });
      // } else {
      //   const groupFlag = this.fullDeliveryGoods.length
      //     ? this.fullDeliveryGoods.length
      //     : 0;
      //   this.fullDeliveryGoods.push({
      //     groupGoods: this.fullDeliveryResult,
      //     giftLimit: this.giftLimit,
      //     groupFlag,
      //     selectLowerLimit: +this.chooseDeliveryAmount
      //   });
      // }
    },
    addItem(list) {
      let totalLimit = 0;
      this.increasePurchaseResult.map(v => {
        totalLimit += v.selectUpperLimit;
      });
      switch (list) {
        // 满送
        case "fullDelivery":
          if (!this.purchasesAmount) {
            this.$message({
              type: "error",
              message: "请输入门槛金额"
            });
          } else if (!+this.chooseDeliveryAmount) {
            this.$message({
              type: "error",
              message: "请输入可选商品数量"
            });
          } else if (!this.fullDeliveryResult.length) {
            this.$message({
              type: "error",
              message: "请添加商品"
            });
          } else {
            const groupFlag = this.fullDeliveryGoods.length
              ? this.fullDeliveryGoods.length
              : 0;
            this.fullDeliveryGoods.push({
              groupGoods: JSON.parse(JSON.stringify(this.fullDeliveryResult)),
              giftLimit: this.giftLimit,
              groupFlag,
              selectLowerLimit: +this.chooseDeliveryAmount
            });
          }
          this.selectedFullDeliveryGoods = [];
          break;
        // 满减
        case "fullReductionRule":
          if (
            +this.discountResult > +this.calcCondition &&
            this.childId === "PriceReduction"
          ) {
            this.$message({
              type: "error",
              message: "满减金额不能大于门槛金额"
            });
          } else if (
            this[list].find(v => +v.calcCondition >= +this.calcCondition)
          ) {
            this.$message({
              type: "error",
              message: "添加门槛金额应大于已有门槛"
            });
          } else if (!this.discountResult || !this.calcCondition) {
            this.$message({
              type: "error",
              message: "请输入门槛金额和优惠金额"
            });
          } else {
            if (this.cyclesTimes > 0) {
              this[list].forEach(v => (v.cyclesTimes = 0));
            }
            this[list].push({
              calcCondition: this.calcCondition,
              discountResult: this.discountResult,
              cyclesTimes: this.cyclesTimes
            });
          }
          break;
        // 满折
        case "fullDiscountRule":
          if (
            this[list].find(v => +v.purchasesAmount == +this.purchasesAmount)
          ) {
            this.$message({
              type: "error",
              message: "添加件数不能等于已有件数！"
            });
          } else if (!this.purchasesAmount || !this.discountRatio) {
            this.$message({
              type: "error",
              message: "请输入件数和折扣！"
            });
          } else if (this.discountRatio > 10) {
            this.$message({
              type: "error",
              message: "折扣限制为10以内的数！"
            });
          } else {
            this[list].push({
              purchasesAmount: this.purchasesAmount,
              discountRatio: this.discountRatio
            });
          }
          break;
        // 加价购
        case "increasePurchaseRules":
          this.markupFee = new Number(this.markupFee);
          if (!this.purchasesAmount || !this.markupFee) {
            this.$message({
              type: "error",
              message: "请添加门槛与加价"
            });
          } else if (this.markupFee == 0) {
            this.$message({
              type: "error",
              message: "加价金额不能为0"
            });
          } else if (!this.increasePurchaseResult.length) {
            this.$message({
              type: "error",
              message: "请添加商品"
            });
          } else if (!this.exchangePurchasesUpperAmount) {
            this.$message({
              type: "error",
              message: "请添加换购件数"
            });
          } else if (
            this[list].find(v => +v.purchasesAmount == +this.purchasesAmount)
          ) {
            this.$message({
              type: "error",
              message: "添加门槛不能等于已有门槛！"
            });
          } else if (+this.exchangePurchasesUpperAmount > totalLimit) {
            this.$message({
              type: "error",
              message: "换购件数应小于或等于商品换购列表上限之和！"
            });
          } else {
            this.increasePurchaseRules.push({
              markupFee: this.markupFee,
              purchasesAmount: this.purchasesAmount,
              exchangePurchasesUpperAmount: this.exchangePurchasesUpperAmount,
              purchaseGoodsList: JSON.parse(
                JSON.stringify(this.increasePurchaseResult)
              )
            });
          }
          break;
        case "combinationPriceRules":
          if (!this.purchasesAmount || !this.combinationPrice) {
            this.$message({
              type: "error",
              message: "请添加门槛与组合价，组合价不能为0"
            });
          } else if (
            this[list].find(v => +v.purchasesAmount == +this.purchasesAmount)
          ) {
            this.$message({
              type: "error",
              message: "添加门槛不能等于已有门槛！"
            });
          } else {
            this.combinationPriceRules.push({
              combinationPrice: this.combinationPrice,
              purchasesAmount: this.purchasesAmount
            });
          }
          break;
        case "pasSuperpositionGiftRuleGoodsModelListResult":
          let selectUpperLimitNum = 0;
          this.superpositionGiftResult.forEach(v=>{
            console.log("v.selectUpperLimit:",v.selectUpperLimit);
            if(v.selectUpperLimit === 0){
              selectUpperLimitNum++;
            }
          })
          console.log("selectUpperLimitNum",selectUpperLimitNum);
          if (!this.superpositionGiftResult.length) {
            this.$message({
              type: "error",
              message: "请添加商品"
            });
          } else if(selectUpperLimitNum>0){
            this.$message({
              type: "error",
              message: "赠送上限不能为0"
            });
          } else {
            console.log("this.superpositionGiftResult:",this.superpositionGiftResult);
            this.pasSuperpositionGiftRuleGoodsModelListResult = JSON.parse(JSON.stringify(this.superpositionGiftResult));
            this.pasSuperpositionGiftRuleGoodsModelListResult.forEach(v=>{
              v.giftNum = v.selectUpperNum;
              v.giftUpperLimitNum  = v.selectUpperLimit;
            })
            console.log("this.pasSuperpositionGiftRuleGoodsModelListResult:",this.pasSuperpositionGiftRuleGoodsModelListResult);
          }
          break;
        default:
          break;
      }
    },
    deleteOverLayItem(list) {
      this[list][0].groupGoods = [];
    },
    deleteItem(list, i) {
      this[list].splice(i, 1);
    },
    showPreviewModal(auditState) {
      const STEP = getCookie({ key: "STEP" });
      switch (this.parentId) {
        // 满额减金额，减件数
        case "FullReduction":
          if (!this.fullReductionRule.length) {
            this.$message({
              type: "error",
              message: "请先添加优惠方式！"
            });
          } else if (
            (!this.calcCondition || !this.discountResult) &&
            !this.fullReductionRule.length
          ) {
            this.$message({
              type: "error",
              message: "请输入门槛和优惠金额！"
            });
          } else {
            this.details = Object.assign(
              this.getCommonParams(STEP, auditState),
              {
                fullReductionRule: this.fullReductionRule
              }
            );
            this.queryCouponLevelList();
            this.previewDiaogVisible = true;
          }
          break;
        // 满件数送商品，满金额送商品
        case "FullDelivery":
          if (this.selectType === "mix") {
            if (!this.fullDeliveryGoods.length) {
              this.$message({
                type: "error",
                message: "请先添加赠送商品！"
              });
            } else {
              this.fullDeliveryGoods.forEach(v => {
                v.giftLimit = this.giftLimit;
                v.groupGoods.forEach(o => {
                  if (o.attrType === "attribute") {
                    o.typeId = o.attrId || o.attributeId;
                    o.typeValue = o.attrValue;
                    o.goodsSn = o.attrId;
                    o.goodsName = o.attrValue;
                  }
                });
              });

              this.details = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDeliveryGoods: this.fullDeliveryGoods,
                  fullDeliveryRule: {
                    chooseDeliveryAmount: this.chooseDeliveryAmount,
                    mustDeliveryAmount: this.mustDeliveryAmount,
                    purchasesAmount: this.purchasesAmount,
                    selectType: this.selectType,
                    giftLimit: this.giftLimit
                  }
                }
              );
              this.queryCouponLevelList();
              this.previewDiaogVisible = true;
            }
          } else if (this.selectType === "same") {
            if (!this.purchasesAmount) {
              this.$message({
                type: "error",
                message: "请先添加门槛！"
              });
            }
            // else if (this.chooseDeliveryAmount === "") {
            //   this.$message({
            //     type: "error",
            //     message: "请先添加可选商品（不添加填入0）！"
            //   });
            // }
            else if (!this.fullDeliveryResult) {
              this.$message({
                type: "error",
                message: "请先添加赠送商品！"
              });
            } else {
              this.fullDeliveryResult.forEach(v => {
                v.goodsName = v.attrValue || v.goodsName;
                // v.goodsSn = v.attrId || v.goodsSn;
              });

              const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                o => o.isMustDelivery === "yes"
              );
              const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                o => o.isMustDelivery === "no" || o.giftLimit === "yes"
              );
              const fullDeliveryGoods = [
                {
                  groupGoods: mustDeliveryGoodsList,
                  giftLimit: this.giftLimit,
                  groupFlag: 0,
                  selectLowerLimit: 1
                }
              ];
              if (notMustDeliveryGoodsList.length) {
                fullDeliveryGoods.push({
                  groupGoods: notMustDeliveryGoodsList,
                  giftLimit: this.giftLimit,
                  groupFlag: 1,
                  selectLowerLimit: +this.chooseDeliveryAmount
                });
              }
              this.details.deleveryGoods = [];
              this.details = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  deleveryGoods: this.fullDeliveryResult,
                  fullDeliveryGoods,
                  fullDeliveryRule: {
                    chooseDeliveryAmount: +this.chooseDeliveryAmount,
                    mustDeliveryAmount: this.mustDeliveryAmount,
                    purchasesAmount: this.purchasesAmount,
                    selectType: this.selectType,
                    giftLimit: this.giftLimit
                  }
                }
              );
              this.$forceUpdate();
              this.queryCouponLevelList();
              this.previewDiaogVisible = true;
            }
          }
          break;

        // 满件数叠加送商品，满金额叠加送商品
        case "FullDeliveryOverlay":
          if (this.overlayType === 'cycle' && (!this.maxCycleTimes || this.maxCycleTimes === "")) {
            this.$message({
              type: "error",
              message: "请填写完整循环叠加规则！"
            });
            return;
          }
          if (this.selectType === "mix") {
            if (!this.fullDeliveryGoods.length) {
              this.$message({
                type: "error",
                message: "请先添加赠送商品！"
              });
            } else {
              if (this.overlayType === "ladder") {
                if (!this.overlayRuleModelList.length) {
                  this.$message({
                    type: "error",
                    message: "请先添加阶梯叠加规则！"
                  });
                } else {
                  let flag = true;
                  this.overlayRuleModelList.forEach(v => {
                    if (v.sendNum === "") {
                      flag = false;
                    }
                  });

                  if (
                    !flag ||
                    this.chooseDeliveryAmount == "" ||
                    (this.chooseDeliveryAmount != 0 &&
                      !this.chooseDeliveryAmount)
                  ) {
                    this.$message({
                      type: "error",
                      message: "请填写完整阶梯叠加规则！"
                    });
                  } else {
                    this.fullDeliveryGoods.forEach(v => {
                      // v.giftLimit = this.giftLimit;
                      v.selectLowerLimit = +this.chooseDeliveryAmount;
                      v.groupGoods.forEach(o => {
                        if (o.attrType === "attribute") {
                          o.typeId = o.attrId || o.attributeId;
                          o.typeValue = o.attrValue;
                          o.goodsSn = o.attrId;
                          o.goodsName = o.attrValue;
                        }
                      });
                    });
                    this.details = Object.assign(
                      this.getCommonParams(STEP, auditState),
                      {
                        fullDeliveryGoods: this.fullDeliveryGoods,
                        fullDeliveryOverlayRuleModel: {
                          overlayRuleModelList: this.overlayRuleModelList,
                          overlayType: this.overlayType,
                          selectType: this.selectType,
                          giftLimit: this.giftLimit
                        }
                      }
                    );
                    this.queryCouponLevelList();
                    this.previewDiaogVisible = true;
                  }
                }
              } else if (this.overlayType === "cycle") {
                if (
                  this.sendNum == "" ||
                  this.purchasesAmount == "" ||
                  this.maxCycleTimes == "" ||
                  (this.chooseDeliveryAmount != 0 && !this.chooseDeliveryAmount)
                ) {
                  this.$message({
                    type: "error",
                    message: "请填写完整循环叠加规则！"
                  });
                } else {
                  this.fullDeliveryGoods.forEach(v => {
                    // v.giftLimit = this.giftLimit;
                    v.selectLowerLimit = +this.chooseDeliveryAmount;
                    v.groupGoods.forEach(o => {
                      if (o.attrType === "attribute") {
                        o.typeId = o.attrId || o.attributeId;
                        o.typeValue = o.attrValue;
                        o.goodsSn = o.attrId;
                        o.goodsName = o.attrValue;
                      }
                    });
                  });
                  this.details = Object.assign(
                    this.getCommonParams(STEP, auditState),
                    {
                      fullDeliveryGoods: this.fullDeliveryGoods,
                      fullDeliveryOverlayRuleModel: {
                        overlayRuleModelList: [
                          {
                            purchasesAmount: this.purchasesAmount,
                            sendNum: this.sendNum,
                            maxCycleTimes: this.maxCycleTimes
                          }
                        ],
                        overlayType: this.overlayType,
                        selectType: this.selectType,
                        giftLimit: this.giftLimit
                      }
                    }
                  );

                  this.queryCouponLevelList();
                  this.previewDiaogVisible = true;
                }
              } else {
                this.fullDeliveryGoods.forEach(v => {
                  v.giftLimit = this.giftLimit;
                  v.groupGoods.forEach(o => {
                    if (o.attrType === "attribute") {
                      o.typeId = o.attrId || o.attributeId;
                      o.typeValue = o.attrValue;
                      o.goodsSn = o.attrId;
                      o.goodsName = o.attrValue;
                    }
                  });
                });
                this.details = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    fullDeliveryGoods: this.fullDeliveryGoods,
                    fullDeliveryOverlayRuleModel: {
                      overlayRuleModelList: [
                        {
                          purchasesAmount: this.purchasesAmount,
                          sendNum: 1
                        }
                      ],
                      overlayType: this.overlayType,
                      selectType: this.selectType,
                      giftLimit: this.giftLimit
                    }
                  }
                );
                this.queryCouponLevelList();
                this.previewDiaogVisible = true;
              }
            }
          } else if (this.selectType === "same") {
            if (this.overlayType === "ladder") {
              if (!this.overlayRuleModelList.length) {
                this.$message({
                  type: "error",
                  message: "请先添加阶梯叠加规则！"
                });
              } else {
                let flag = true;
                this.overlayRuleModelList.forEach(v => {
                  if (v.sendNum === "") {
                    flag = false;
                  }
                });
                if (
                  !flag ||
                  (this.chooseDeliveryAmount != 0 && !this.chooseDeliveryAmount)
                ) {
                  this.$message({
                    type: "error",
                    message: "请填写完整阶梯叠加规则！"
                  });
                } else {
                  this.fullDeliveryResult.forEach(v => {
                    v.goodsName = v.attrValue || v.goodsName;
                    // v.goodsSn = v.attrId || v.goodsSn;
                  });
                  const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                    o => o.isMustDelivery === "yes"
                  );
                  const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                    o => o.isMustDelivery === "no" || o.giftLimit === "yes"
                  );
                  const fullDeliveryGoods = [
                    {
                      groupGoods: mustDeliveryGoodsList,
                      giftLimit: this.giftLimit,
                      groupFlag: 0,
                      selectLowerLimit: 1
                    }
                  ];
                  if (notMustDeliveryGoodsList.length) {
                    fullDeliveryGoods.push({
                      groupGoods: notMustDeliveryGoodsList,
                      giftLimit: this.giftLimit,
                      groupFlag: 1,
                      selectLowerLimit: +this.chooseDeliveryAmount
                    });
                  }
                  this.details.deleveryGoods = [];
                  this.details = Object.assign(
                    this.getCommonParams(STEP, auditState),
                    {
                      deleveryGoods: this.fullDeliveryResult,
                      fullDeliveryGoods,
                      fullDeliveryOverlayRuleModel: {
                        overlayRuleModelList: this.overlayRuleModelList,
                        overlayType: this.overlayType,
                        selectType: this.selectType,
                        giftLimit: this.giftLimit
                      }
                    }
                  );
                  this.queryCouponLevelList();
                  this.previewDiaogVisible = true;
                }
              }
            } else if (this.overlayType === "cycle") {
              if (
                this.sendNum == "" ||
                this.purchasesAmount == "" ||
                this.maxCycleTimes == "" ||
                (this.chooseDeliveryAmount != 0 && !this.chooseDeliveryAmount)
              ) {
                this.$message({
                  type: "error",
                  message: "请填写完整循环叠加规则！"
                });
              } else {
                this.fullDeliveryResult.forEach(v => {
                  v.goodsName = v.attrValue || v.goodsName;
                  // v.goodsSn = v.attrId || v.goodsSn;
                });
                const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "yes"
                );
                const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "no" || o.giftLimit === "yes"
                );
                const fullDeliveryGoods = [
                  {
                    groupGoods: mustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 0,
                    selectLowerLimit: 1
                  }
                ];
                if (notMustDeliveryGoodsList.length) {
                  fullDeliveryGoods.push({
                    groupGoods: notMustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 1,
                    selectLowerLimit: +this.chooseDeliveryAmount
                  });
                }
                this.details.deleveryGoods = [];
                this.details = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    deleveryGoods: this.fullDeliveryResult,
                    fullDeliveryGoods,
                    fullDeliveryOverlayRuleModel: {
                      overlayRuleModelList: [
                        {
                          purchasesAmount: this.purchasesAmount,
                          sendNum: this.sendNum,
                          maxCycleTimes: this.maxCycleTimes
                        }
                      ],
                      overlayType: this.overlayType,
                      selectType: this.selectType,
                      giftLimit: this.giftLimit
                    }
                  }
                );
                this.queryCouponLevelList();
                this.previewDiaogVisible = true;
              }
            } else {
              if (!this.purchasesAmount) {
                this.$message({
                  type: "error",
                  message: "请先添加门槛！"
                });
              }
              // else if (this.chooseDeliveryAmount === "") {
              //   this.$message({
              //     type: "error",
              //     message: "请先添加可选商品（不添加填入0）！"
              //   });
              // }
              else if (!this.fullDeliveryResult) {
                this.$message({
                  type: "error",
                  message: "请先添加赠送商品！"
                });
              } else {
                this.fullDeliveryResult.forEach(v => {
                  v.goodsName = v.attrValue || v.goodsName;
                  // v.goodsSn = v.attrId || v.goodsSn;
                });
                const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "yes"
                );
                const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "no" || o.giftLimit === "yes"
                );
                const fullDeliveryGoods = [
                  {
                    groupGoods: mustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 0,
                    selectLowerLimit: 1
                  }
                ];
                if (notMustDeliveryGoodsList.length) {
                  fullDeliveryGoods.push({
                    groupGoods: notMustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 1,
                    selectLowerLimit: +this.chooseDeliveryAmount
                  });
                }
                this.details.deleveryGoods = [];
                this.details = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    deleveryGoods: this.fullDeliveryResult,
                    fullDeliveryGoods,
                    fullDeliveryOverlayRuleModel: {
                      overlayRuleModelList: [
                        {
                          purchasesAmount: this.purchasesAmount,
                          sendNum: this.chooseDeliveryAmount
                        }
                      ],
                      selectType: this.selectType,
                      overlayType: this.overlayType,
                      giftLimit: this.giftLimit
                    }
                  }
                );

                this.queryCouponLevelList();
                this.previewDiaogVisible = true;
              }
            }
          }

          break;
        // 满件数加价换购
        case "IncreasePurchase":
          if (this.increasePurchaseRules.length) {
            this.details = Object.assign(
              this.getCommonParams(STEP, auditState),
              {
                increasePurchaseRules: this.increasePurchaseRules
              }
            );
            this.queryCouponLevelList();
            this.previewDiaogVisible = true;
          } else {
            this.$message({
              type: "error",
              message: "请先添加促销规则！"
            });
          }
          break;
        // 满件数打折
        case "FullDiscount":
          if (this.discountMode === "fullPriceDiscount") {
            if (!this.fullDiscountRule.length) {
              this.$message({
                type: "error",
                message: "请先添加优惠方式！"
              });
            } else {
              this.fullDiscountRule.forEach(
                v => (v.discountMode = this.discountMode)
              );
              this.details = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDiscountRule: this.fullDiscountRule
                }
              );
              this.queryCouponLevelList();
              this.previewDiaogVisible = true;
            }
          } else if (this.discountMode === "floorPriceDiscount") {
            if (
              !this.purchasesAmount ||
              (!this.discountRatio && this.discountRatio !== 0)
            ) {
              this.$message({
                type: "error",
                message: "请输入门槛和折扣！"
              });
            } else {
              this.fullDiscountRule = [
                {
                  purchasesAmount: this.purchasesAmount,
                  discountRatio: this.discountRatio,
                  discountMode: this.discountMode
                }
              ];
              this.details = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDiscountRule: this.fullDiscountRule
                }
              );
              this.queryCouponLevelList();
              this.previewDiaogVisible = true;
            }
          }
          break;
        // 特价
        case "SpecialPrice":
          let flag = true;
          let limtRatio = true;
          this.listHot.map(v => {
            if (v.discountPrice == 0 || v.discountRatio == 0) {
              flag = false;
            } else if (new Number(v.discountRatio) >= 10) {
              limtRatio = false;
            }
          });
          if (flag) {
            if (limtRatio) {
              // eslint-disable-next-line no-case-declarations
              const isEmptyPurchasesUpperLimit = this.listHot.filter(
                v => !v.purchasesUpperLimit && v.totalStockNum !== 0
              ).length;
              // eslint-disable-next-line no-case-declarations
              const isEmptyTotalStockNum = this.listHot.filter(
                v => !v.totalStockNum && v.totalStockNum !== 0
              ).length;
              // eslint-disable-next-line no-case-declarations
              const isEmptyDiscountRatio = this.listHot.filter(
                v => !v.discountRatio && v.discountRatio !== 0
              ).length;
              // eslint-disable-next-line no-case-declarations
              const isEmptyDiscountPrice = this.listHot.filter(
                v => !v.discountPrice && v.discountPrice !== 0
              ).length;
              if (!this.listHot || !this.listHot.length) {
                this.$message({
                  type: "error",
                  message: "请先添加商品"
                });
              } else if (
                isEmptyPurchasesUpperLimit ||
                isEmptyTotalStockNum ||
                isEmptyDiscountRatio ||
                isEmptyDiscountPrice
              ) {
                this.$message({
                  type: "error",
                  message: "请先输入单人限购、库存、折扣率、与折扣金额"
                });
              } else {
                this.details = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    listHot: this.listHot
                  }
                );

                this.previewDiaogVisible = true;
              }
            } else {
              this.$message({
                type: "error",
                message: "折扣率需小于10!"
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "折扣率、折扣价不能为0!"
            });
          }

          break;
        // 打包价
        case "CombinationPrice":
          if (!this.combinationResult.length) {
            this.$message({
              type: "error",
              message: "请添加商品！"
            });
          } else if (!this.combinationPriceRules.length) {
            this.$message({
              type: "error",
              message: "请添加促销内容！"
            });
          } else {
            this.details = Object.assign(
              this.getCommonParams(STEP, auditState),
              {
                combinationPriceRules: this.combinationPriceRules,
                combinationPriceGoods: this.combinationResult
              }
            );
            this.previewDiaogVisible = true;
          }
          break;
        default:
          break;
      }
      this.details = Object.assign(this.details, {
        storeList: STEP.step2.storeListRes
      });
    },
    submit(auditState) {
      const STEP = getCookie({ key: "STEP" });
      const { id } = STEP.step1;
      console.log("this.parentId:", this.parentId);
      switch (this.parentId) {
        // 满额减金额，减件数
        case "FullReduction":
          if (!this.fullReductionRule.length) {
            this.$message({
              type: "error",
              message: "请先添加优惠方式！"
            });
          } else if (
            (!this.calcCondition || !this.discountResult) &&
            !this.fullReductionRule.length
          ) {
            this.$message({
              type: "error",
              message: "请输入门槛和优惠金额！"
            });
          } else {
            const params = Object.assign(
              this.getCommonParams(STEP, auditState),
              {
                fullReductionRule: this.fullReductionRule
              }
            );

            if (this.disabledFirst && !this.isCopy) {
              params.basicConfigInfo.id = id;
              this.$store
                .dispatch("editSubmitFullReduction", params)
                .then(() => {
                  this.backAndClear();
                });
            } else {
              this.$store.dispatch("submitFullReduction", params).then(() => {
                this.backAndClear();
              });
            }
          }
          break;
        // 满件数送商品，满金额送商品
        case "FullDelivery":
          if (this.selectType === "mix") {
            if (!this.fullDeliveryGoods.length) {
              this.$message({
                type: "error",
                message: "请先添加赠送商品！"
              });
            } else {
              this.fullDeliveryGoods.forEach(v => {
                v.giftLimit = this.giftLimit;
                v.groupGoods.forEach(o => {
                  if (o.attrType === "attribute") {
                    o.typeId = o.attrId || o.attributeId;
                    o.typeValue = o.attrValue;
                    o.goodsSn = o.attrId;
                    o.goodsName = o.attrValue;
                  }
                });
              });
              const params = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDeliveryGoods: this.fullDeliveryGoods,
                  fullDeliveryRule: {
                    purchasesAmount: this.purchasesAmount,
                    selectType: this.selectType,
                    giftLimit: this.giftLimit
                  }
                }
              );
              if (this.disabledFirst && !this.isCopy) {
                params.basicConfigInfo.id = id;
                this.$store
                  .dispatch("editSubmitFullDelivery", params)
                  .then(() => {
                    this.backAndClear();
                  });
              } else {
                this.$store.dispatch("submitFullDelivery", params).then(() => {
                  this.backAndClear();
                });
              }
            }
          } else if (this.selectType === "same") {
            if (!this.purchasesAmount) {
              this.$message({
                type: "error",
                message: "请先添加门槛！"
              });
            }
            // else if (this.chooseDeliveryAmount === "") {
            //   this.$message({
            //     type: "error",
            //     message: "请先添加可选商品（不添加填入0）！"
            //   });
            // }
            else if (!this.fullDeliveryResult) {
              this.$message({
                type: "error",
                message: "请先添加赠送商品！"
              });
            } else {
              const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                o => o.isMustDelivery === "yes"
              );
              const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                o => o.isMustDelivery === "no" || o.giftLimit === "yes"
              );
              const fullDeliveryGoods = [
                {
                  groupGoods: mustDeliveryGoodsList,
                  giftLimit: this.giftLimit,
                  groupFlag: 0,
                  selectLowerLimit: 1
                }
              ];
              if (notMustDeliveryGoodsList.length) {
                fullDeliveryGoods.push({
                  groupGoods: notMustDeliveryGoodsList,
                  giftLimit: this.giftLimit,
                  groupFlag: 1,
                  selectLowerLimit: +this.chooseDeliveryAmount
                });
              }
              const params = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDeliveryGoods,
                  fullDeliveryRule: {
                    purchasesAmount: this.purchasesAmount,
                    selectType: this.selectType,
                    giftLimit: this.giftLimit
                  }
                }
              );
              if (this.disabledFirst && !this.isCopy) {
                params.basicConfigInfo.id = id;
                this.$store
                  .dispatch("editSubmitFullDelivery", params)
                  .then(() => {
                    this.backAndClear();
                  });
              } else {
                this.$store.dispatch("submitFullDelivery", params).then(() => {
                  this.backAndClear();
                });
              }
            }
          }
          break;
        // 满件数叠加送商品，满金额叠加送商品
        case "FullDeliveryOverlay":
          console.log("this.selectType:", this.selectType);
          console.log("this.overlayType:", this.overlayType);
          if (this.selectType === "mix") {
            if (!this.fullDeliveryGoods.length) {
              this.$message({
                type: "error",
                message: "请先添加赠送商品！"
              });
            } else {
              if (this.overlayType === "ladder") {
                if (!this.overlayRuleModelList.length) {
                  this.$message({
                    type: "error",
                    message: "请先添加阶梯叠加规则！"
                  });
                } else {
                  let flag = true;
                  this.overlayRuleModelList.forEach(v => {
                    if (v.sendNum === "") {
                      flag = false;
                    }
                  });
                  if (
                    !flag ||
                    (this.chooseDeliveryAmount != 0 &&
                      !this.chooseDeliveryAmount)
                  ) {
                    this.$message({
                      type: "error",
                      message: "请填写完整阶梯叠加规则！"
                    });
                  } else {
                    this.fullDeliveryGoods.forEach(v => {
                      v.giftLimit = this.giftLimit;
                      v.selectLowerLimit = +this.chooseDeliveryAmount;
                      v.groupGoods.forEach(o => {
                        if (o.attrType === "attribute") {
                          o.typeId = o.attrId || o.attributeId;
                          o.typeValue = o.attrValue;
                          o.goodsSn = o.attrId;
                          o.goodsName = o.attrValue;
                        }
                      });
                    });
                    const params = Object.assign(
                      this.getCommonParams(STEP, auditState),
                      {
                        fullDeliveryGoods: this.fullDeliveryGoods,
                        fullDeliveryOverlayRuleModel: {
                          overlayRuleModelList: this.overlayRuleModelList,
                          overlayType: this.overlayType,
                          selectType: this.selectType,
                          giftLimit: this.giftLimit
                        }
                      }
                    );
                    if (this.disabledFirst && !this.isCopy) {
                      params.basicConfigInfo.id = id;
                      this.$store
                        .dispatch("editSubmitFullDeliveryOverlay", params)
                        .then(() => {
                          this.backAndClear();
                        });
                    } else {
                      this.$store
                        .dispatch("submitFullDeliveryOverLay", params)
                        .then(() => {
                          this.backAndClear();
                        });
                    }
                  }
                }
              } else if (this.overlayType === "cycle") {
                if (this.fullDeliveryGoods) {
                  this.fullDeliveryGoods.forEach(goods=>{
                    if (goods.groupGoods) {
                      goods.groupGoods.forEach(gg=>{
                        if (!gg.goodsPackageNum) {
                          this.goodsPackageNumFlag = false;
                        }
                      })
                    }
                    if (!this.goodsPackageNumFlag) {
                      this.$message({
                        type: "error",
                        message: "请填写商品数量！"
                      });
                    }
                  })
                }
                if (
                  this.sendNum == "" ||
                  this.purchasesAmount == "" ||
                  this.maxCycleTimes == "" ||
                  (this.chooseDeliveryAmount != 0 && !this.chooseDeliveryAmount)
                ) {
                  this.$message({
                    type: "error",
                    message: "请填写完整循环叠加规则！"
                  });
                } else {
                  this.fullDeliveryGoods.forEach(v => {
                    v.giftLimit = this.giftLimit;
                    v.selectLowerLimit = +this.chooseDeliveryAmount;
                    v.groupGoods.forEach(o => {
                      if (o.attrType === "attribute") {
                        o.typeId = o.attrId || o.attributeId;
                        o.typeValue = o.attrValue;
                        o.goodsSn = o.attrId;
                        o.goodsName = o.attrValue;
                      }
                    });
                  });
                  const params = Object.assign(
                    this.getCommonParams(STEP, auditState),
                    {
                      fullDeliveryGoods: this.fullDeliveryGoods,
                      fullDeliveryOverlayRuleModel: {
                        overlayRuleModelList: [
                          {
                            purchasesAmount: this.purchasesAmount,
                            sendNum: this.sendNum,
                            maxCycleTimes: this.maxCycleTimes
                          }
                        ],
                        overlayType: this.overlayType,
                        selectType: this.selectType,
                        giftLimit: this.giftLimit
                      }
                    }
                  );
                  if(this.goodsPackageNumFlag) {
                    if (this.disabledFirst && !this.isCopy) {
                      params.basicConfigInfo.id = id;
                      this.$store
                          .dispatch("editSubmitFullDeliveryOverlay", params)
                          .then(() => {
                            this.backAndClear();
                          });
                    } else {
                      this.$store
                          .dispatch("submitFullDeliveryOverLay", params)
                          .then(() => {
                            this.backAndClear();
                          });
                    }
                  }
                  this.goodsPackageNumFlag = true;
                }
              } else {
                this.fullDeliveryGoods.forEach(v => {
                  v.giftLimit = this.giftLimit;
                  v.groupGoods.forEach(o => {
                    if (o.attrType === "attribute") {
                      o.typeId = o.attrId || o.attributeId;
                      o.typeValue = o.attrValue;
                      o.goodsSn = o.attrId;
                      o.goodsName = o.attrValue;
                    }
                  });
                });
                const params = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    fullDeliveryGoods: this.fullDeliveryGoods,
                    fullDeliveryOverlayRuleModel: {
                      overlayRuleModelList: [
                        {
                          purchasesAmount: this.purchasesAmount,
                          sendNum: 1
                        }
                      ],
                      overlayType: this.overlayType,
                      selectType: this.selectType,
                      giftLimit: this.giftLimit
                    }
                  }
                );
                if (this.disabledFirst && !this.isCopy) {
                  params.basicConfigInfo.id = id;
                  this.$store
                    .dispatch("editSubmitFullDeliveryOverlay", params)
                    .then(() => {
                      this.backAndClear();
                    });
                } else {
                  this.$store
                    .dispatch("submitFullDeliveryOverLay", params)
                    .then(() => {
                      this.backAndClear();
                    });
                }
              }
            }
          } else if (this.selectType === "same") {
            if (this.overlayType === "ladder") {
              if (!this.overlayRuleModelList.length) {
                this.$message({
                  type: "error",
                  message: "请先添加阶梯叠加规则！"
                });
              } else {
                let flag = true;
                this.overlayRuleModelList.forEach(v => {
                  if (v.sendNum === "") {
                    flag = false;
                  }
                });
                if (
                  !flag ||
                  (this.chooseDeliveryAmount != 0 && !this.chooseDeliveryAmount)
                ) {
                  this.$message({
                    type: "error",
                    message: "请填写完整阶梯叠加规则！"
                  });
                } else {
                  const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                    o => o.isMustDelivery === "yes"
                  );
                  const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                    o => o.isMustDelivery === "no" || o.giftLimit === "yes"
                  );
                  const fullDeliveryGoods = [
                    {
                      groupGoods: mustDeliveryGoodsList,
                      giftLimit: this.giftLimit,
                      groupFlag: 0,
                      selectLowerLimit: 1
                    }
                  ];
                  if (notMustDeliveryGoodsList.length) {
                    fullDeliveryGoods.push({
                      groupGoods: notMustDeliveryGoodsList,
                      giftLimit: this.giftLimit,
                      groupFlag: 1,
                      selectLowerLimit: +this.chooseDeliveryAmount
                    });
                  }
                  const params = Object.assign(
                    this.getCommonParams(STEP, auditState),
                    {
                      fullDeliveryGoods,
                      fullDeliveryOverlayRuleModel: {
                        overlayRuleModelList: this.overlayRuleModelList,
                        overlayType: this.overlayType,
                        selectType: this.selectType,
                        giftLimit: this.giftLimit
                      }
                    }
                  );
                  if (this.disabledFirst && !this.isCopy) {
                    params.basicConfigInfo.id = id;
                    this.$store
                      .dispatch("editSubmitFullDeliveryOverlay", params)
                      .then(() => {
                        this.backAndClear();
                      });
                  } else {
                    this.$store
                      .dispatch("submitFullDeliveryOverLay", params)
                      .then(() => {
                        this.backAndClear();
                      });
                  }
                }
              }
            } else if (this.overlayType === "cycle") {
              if (
                this.sendNum == "" ||
                this.purchasesAmount == "" ||
                this.maxCycleTimes == "" ||
                (this.chooseDeliveryAmount != 0 && !this.chooseDeliveryAmount)
              ) {
                this.$message({
                  type: "error",
                  message: "请填写完整循环叠加规则！"
                });
              } else {
                const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "yes"
                );
                const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "no" || o.giftLimit === "yes"
                );
                const fullDeliveryGoods = [
                  {
                    groupGoods: mustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 0,
                    selectLowerLimit: 1
                  }
                ];
                if (notMustDeliveryGoodsList.length) {
                  fullDeliveryGoods.push({
                    groupGoods: notMustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 1,
                    selectLowerLimit: +this.chooseDeliveryAmount
                  });
                }
                const params = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    fullDeliveryGoods,
                    fullDeliveryOverlayRuleModel: {
                      overlayRuleModelList: [
                        {
                          purchasesAmount: this.purchasesAmount,
                          sendNum: this.sendNum,
                          maxCycleTimes: this.maxCycleTimes
                        }
                      ],
                      overlayType: this.overlayType,
                      selectType: this.selectType,
                      giftLimit: this.giftLimit
                    }
                  }
                );
                if (this.disabledFirst && !this.isCopy) {
                  params.basicConfigInfo.id = id;
                  this.$store
                    .dispatch("editSubmitFullDeliveryOverlay", params)
                    .then(() => {
                      this.backAndClear();
                    });
                } else {
                  this.$store
                    .dispatch("submitFullDeliveryOverLay", params)
                    .then(() => {
                      this.backAndClear();
                    });
                }
              }
            } else {
              if (!this.purchasesAmount) {
                this.$message({
                  type: "error",
                  message: "请先添加门槛！"
                });
              }
              // else if (this.chooseDeliveryAmount === "") {
              //   this.$message({
              //     type: "error",
              //     message: "请先添加可选商品（不添加填入0）！"
              //   });
              // }
              else if (!this.fullDeliveryResult) {
                this.$message({
                  type: "error",
                  message: "请先添加赠送商品！"
                });
              } else {
                const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "yes"
                );
                const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
                  o => o.isMustDelivery === "no" || o.giftLimit === "yes"
                );
                const fullDeliveryGoods = [
                  {
                    groupGoods: mustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 0,
                    selectLowerLimit: 1
                  }
                ];
                if (notMustDeliveryGoodsList.length) {
                  fullDeliveryGoods.push({
                    groupGoods: notMustDeliveryGoodsList,
                    giftLimit: this.giftLimit,
                    groupFlag: 1,
                    selectLowerLimit: +this.chooseDeliveryAmount
                  });
                }
                const params = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    fullDeliveryGoods,
                    fullDeliveryOverlayRuleModel: {
                      overlayRuleModelList: [
                        {
                          purchasesAmount: this.purchasesAmount,
                          sendNum: 0
                        }
                      ],
                      selectType: this.selectType,
                      overlayType: this.overlayType,
                      giftLimit: this.giftLimit
                    }
                  }
                );
                if (this.disabledFirst && !this.isCopy) {
                  params.basicConfigInfo.id = id;
                  this.$store
                    .dispatch("editSubmitFullDeliveryOverlay", params)
                    .then(() => {
                      this.backAndClear();
                    });
                } else {
                  this.$store
                    .dispatch("submitFullDeliveryOverLay", params)
                    .then(() => {
                      this.backAndClear();
                    });
                }
              }
            }
          }
          break;
        // 满件数加价换购
        case "IncreasePurchase":
          if (this.increasePurchaseRules.length) {
            const params = Object.assign(
              this.getCommonParams(STEP, auditState),
              {
                increasePurchaseRules: this.increasePurchaseRules
              }
            );
            if (this.disabledFirst && !this.isCopy) {
              params.basicConfigInfo.id = id;
              this.$store
                .dispatch("editSubmitIncreaseRule", params)
                .then(() => {
                  this.backAndClear();
                });
            } else {
              this.$store.dispatch("submitIncreaseRule", params).then(() => {
                this.backAndClear();
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请先添加促销规则！"
            });
          }
          break;
        // 满件数打折
        case "FullDiscount":
          if (this.discountMode === "fullPriceDiscount") {
            if (!this.fullDiscountRule.length) {
              this.$message({
                type: "error",
                message: "请先添加优惠方式！"
              });
            } else {
              this.fullDiscountRule.forEach(
                v => (v.discountMode = this.discountMode)
              );
              const params = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDiscountRule: this.fullDiscountRule
                }
              );
              if (this.disabledFirst && !this.isCopy) {
                params.basicConfigInfo.id = id;
                this.$store
                  .dispatch("editSubmitFullDiscount", params)
                  .then(() => {
                    this.backAndClear();
                  });
              } else {
                this.$store.dispatch("submitFullDiscount", params).then(() => {
                  this.backAndClear();
                });
              }
            }
          } else if (this.discountMode === "floorPriceDiscount") {
            if (
              !this.purchasesAmount ||
              (!this.discountRatio && this.discountRatio !== 0)
            ) {
              this.$message({
                type: "error",
                message: "请输入门槛和折扣！"
              });
            } else {
              this.fullDiscountRule = [
                {
                  purchasesAmount: this.purchasesAmount,
                  discountRatio: this.discountRatio,
                  discountMode: this.discountMode
                }
              ];
              let params = Object.assign(
                this.getCommonParams(STEP, auditState),
                {
                  fullDiscountRule: this.fullDiscountRule
                }
              );
              if (this.disabledFirst && !this.isCopy) {
                params.basicConfigInfo.id = id;
                this.$store
                  .dispatch("editSubmitFullDiscount", params)
                  .then(() => {
                    this.backAndClear();
                  });
              } else {
                this.$store.dispatch("submitFullDiscount", params).then(() => {
                  this.backAndClear();
                });
              }
            }
          }
          break;
        // 特价
        case "SpecialPrice":
          // eslint-disable-next-line no-case-declarations
          let flag = true;
          let limtRatio = true;
          this.listHot.map(v => {
            if (v.discountPrice == 0 || v.discountRatio == 0) {
              flag = false;
            } else if (new Number(v.discountRatio) >= 10) {
              limtRatio = false;
            }
          });
          if (flag) {
            if (limtRatio) {
              const isEmptyPurchasesUpperLimit = this.listHot.filter(
                v => !v.purchasesUpperLimit && v.totalStockNum !== 0
              ).length;
              // eslint-disable-next-line no-case-declarations
              const isEmptyTotalStockNum = this.listHot.filter(
                v => !v.totalStockNum && v.totalStockNum !== 0
              ).length;
              // eslint-disable-next-line no-case-declarations
              const isEmptyDiscountRatio = this.listHot.filter(
                v => !v.discountRatio && v.discountRatio !== 0
              ).length;
              // eslint-disable-next-line no-case-declarations
              const isEmptyDiscountPrice = this.listHot.filter(
                v => !v.discountPrice && v.discountPrice !== 0
              ).length;
              if (!this.listHot || !this.listHot.length) {
                this.$message({
                  type: "error",
                  message: "请先添加商品"
                });
              } else if (
                isEmptyPurchasesUpperLimit ||
                isEmptyTotalStockNum ||
                isEmptyDiscountRatio ||
                isEmptyDiscountPrice
              ) {
                this.$message({
                  type: "error",
                  message: "请先输入单人限购、库存、折扣率、与折扣金额"
                });
              } else {
                this.listHot.forEach(v=>{
                  v.showUpperNum = this.showUpperNum;
                })
                // 提交入参：将 shopPrices 字段重命名为 shopPrice，避免影响页面展示
                const listHotParams = this.listHot.map(v => {
                  const { shopPrices, shopPrice, ...rest } = v;
                  // 兼容两种字段名：优先 shopPrices，缺失时回退 shopPrice，避免编辑回显场景覆盖丢失
                  return Object.assign({}, rest, { shopPrice: shopPrices ?? shopPrice });
                });
                const params = Object.assign(
                  this.getCommonParams(STEP, auditState),
                  {
                    listHot: listHotParams
                  }
                );
                if (this.disabledFirst && !this.isCopy) {
                  params.basicConfigInfo.id = id;
                  this.$store
                    .dispatch("editSubmitSpecialRule", params)
                    .then(() => {
                      this.backAndClear();
                    });
                } else {                  
                  this.$store.dispatch("submitSpecialRule", params).then(() => {
                    this.backAndClear();
                  });
                }
              }
            } else {
              this.$message({
                type: "error",
                message: "折扣率需小于10!"
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "折扣率、折扣价不能为0!"
            });
          }

          break;
        // 打包价
        case "CombinationPrice":
          if (!this.combinationResult.length) {
            this.$message({
              type: "error",
              message: "请添加商品！"
            });
          } else if (!this.combinationPriceRules.length) {
            this.$message({
              type: "error",
              message: "请添加促销内容！"
            });
          } else {
            const params = Object.assign(
              this.getCommonParams(STEP, auditState),
              {
                combinationPriceRules: this.combinationPriceRules,
                combinationPriceGoods: this.combinationResult
              }
            );
            if (this.disabledFirst && !this.isCopy) {
              params.basicConfigInfo.id = id;
              this.$store
                .dispatch("editSubmitCombinationRule", params)
                .then(() => {
                  this.backAndClear();
                });
            } else {
              this.$store.dispatch("submitCombinationRule", params).then(() => {
                this.backAndClear();
              });
            }
          }
          break;
        // 叠加赠送
        case "SuperpositionGift":
          console.log("叠加赠送提交!")
          if(!this.pasSuperpositionGiftRuleGoodsModelListResult.length){
            this.$message({
              type: "error",
              message: "请先添加赠送商品！"
            });
          }else if(!this.pasSuperpositionGiftRuleLimitModel.purchasesAmount){
            this.$message({
              type: "error",
              message: "请先输入赠送条件！"
            });
          }else{
            const data = getCookie({ key: "STEP" });
            let step4;
            const params = Object.assign(
              this.getCommonParams(STEP, auditState),              
            );
            if (data.step4) {
              step4 = {
                pasSuperpositionGiftRuleGoodsModelList: this.pasSuperpositionGiftRuleGoodsModelListResult,
                pasSuperpositionGiftRuleLimitModel: this.pasSuperpositionGiftRuleLimitModel,
              }
            } else {
              step4 = {
                pasSuperpositionGiftRuleGoodsModelList: this.pasSuperpositionGiftRuleGoodsModelListResult,
                pasSuperpositionGiftRuleLimitModel: this.pasSuperpositionGiftRuleLimitModel,
              }
            }
            Object.assign(data, {step4:step4});
            setCookie({ key: "STEP", data });
            console.log("data:",data);
            const route = {
              name: "ConnectedActivities"
            };
            if (this.disabledFirst) {
              if (!this.isCopy) {
                Object.assign(route, {
                  query: {
                    type: "edit"
                  }
                });
              } else {
                Object.assign(route, {
                  query: {
                    type: "edit",
                    subType: "copy"
                  }
                });
              }
            }
            this.$router.push(route);
            return false;
            if (this.disabledFirst && !this.isCopy) {
              params.basicConfigInfo.id = id;
              this.$store
                .dispatch("editSuperpositionGift", params)
                .then(() => {
                  this.backAndClear();
                });
            } else {
              this.$store
                .dispatch("createSuperpositionGift", params)
                .then(() => {
                  this.backAndClear();
                });
            }
          }
          break;
        default:
          break;
      }
    },
    // 生成满送商品
    createFullDeliveryOverlayGoods() {
      if (this.selectType === "same") {
        const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
          o => o.isMustDelivery === "yes"
        );
        const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
          o => o.isMustDelivery === "no" || o.giftLimit === "yes"
        );

        const fullDeliveryGoods = this.fullDeliveryResult.length
          ? []
          : [
              {
                groupGoods: mustDeliveryGoodsList,
                giftLimit: this.giftLimit,
                groupFlag: 0,
                selectLowerLimit: 1
              }
            ];
        if (notMustDeliveryGoodsList.length) {
          fullDeliveryGoods.push({
            groupGoods: notMustDeliveryGoodsList,
            giftLimit: this.giftLimit,
            groupFlag: 1,
            selectLowerLimit: +this.chooseDeliveryAmount
          });
        }

        this.fullDeliveryGoods = fullDeliveryGoods;
      } else {
        const groupFlag = this.fullDeliveryGoods.length
          ? this.fullDeliveryGoods.length
          : 0;

        if (!this.fullDeliveryGoods.length) {
          this.fullDeliveryGoods.push({
            groupGoods: this.fullDeliveryResult,
            giftLimit: this.giftLimit,
            groupFlag,
            selectLowerLimit: +this.chooseDeliveryAmount
          });
        }
      }
    },
    // 生成满送商品
    createFullDeliveryGoods() {
      if (this.selectType === "same") {
        const mustDeliveryGoodsList = this.fullDeliveryResult.filter(
          o => o.isMustDelivery === "yes"
        );
        const notMustDeliveryGoodsList = this.fullDeliveryResult.filter(
          o => o.isMustDelivery === "no" || o.giftLimit === "yes"
        );
        const fullDeliveryGoods = [
          {
            groupGoods: mustDeliveryGoodsList,
            giftLimit: this.giftLimit,
            groupFlag: 0,
            selectLowerLimit: 1
          }
        ];
        if (notMustDeliveryGoodsList.length) {
          fullDeliveryGoods.push({
            groupGoods: notMustDeliveryGoodsList,
            giftLimit: this.giftLimit,
            groupFlag: 1,
            selectLowerLimit: +this.chooseDeliveryAmount
          });
        }
        this.fullDeliveryGoods = fullDeliveryGoods;
      } else {
        const groupFlag = this.fullDeliveryGoods.length
          ? this.fullDeliveryGoods.length
          : 0;

        if (!this.fullDeliveryGoods.length) {
          this.fullDeliveryGoods.push({
            groupGoods: this.fullDeliveryResult,
            giftLimit: this.giftLimit,
            groupFlag,
            selectLowerLimit: +this.chooseDeliveryAmount
          });
        }
      }
    },
    backAndClear() {
      this.$router.push({ name: "ActivityList" });
      removeCookie({ key: "STEP" });
    },
    getCommonParams(STEP, auditState) {
      console.log("STEP: ", STEP);
      const params = {
        basicConfigInfo: {
          auditState,
          promotionCode: STEP.step1.parentId + "-" + STEP.step1.childId,
          assignPriceType: STEP.step2.assignPriceType,
          introText: STEP.step2.introText,
          promotionName: STEP.step2.promotionName,
          runningTimeType: STEP.step2.runningTimeType,
          pasLevel: STEP.step2.pasLevel,
          plusTag: STEP.step2.plusTag,
          couponUsable: STEP.step2.couponUsable
        },
        dateConfigInfo: {
          dateType: STEP.step2.dateType,
          dateValues:
            STEP.step2.dateType === "day"
              ? [STEP.step2.dateValue]
              : STEP.step2.dateValue,
          promotionStartDate: STEP.step2.promotionStartDate,
          promotionEndDate: STEP.step2.promotionEndDate
        },
        dateConfigRange: STEP.step2.dateConfigRange,
        pasCalendars: {
          promotionStartTime: STEP.step2.promotionStartTime,
          promotionEndTime: STEP.step2.promotionEndTime
        },
        pasGoods: STEP.step3,
        pasLabels: STEP.step2.tags,
        pasOutlets: STEP.step2.storeListFormat,
        platformModels: STEP.step2.platformModels,
        memberGroupList: STEP.step2.groupListFormat,
        groupListRes: STEP.step2.groupListRes,
        showUpperNum: STEP.step2.showUpperNum,
      };
      return params;
    },
    back() {
      this.$router.back(-1);
    },
    filterGt0OrOverlayList(prop, i) {
      this.overlayRuleModelList[i][prop] = this.overlayRuleModelList[i][
        prop
      ].replace(/^(0+)/, ""); //过滤0开头
      this.overlayRuleModelList[i][prop] = this.overlayRuleModelList[i][
        prop
      ].replace(/[^\d]/g, "");
      this.overlayRuleModelList[i][prop] = this.overlayRuleModelList[i][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0OrOverlay(prop) {
      if (this.childId === "PriceDeliveryOverlay") {
        this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
        this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this[prop] = this[prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
        this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
        if (this[prop].indexOf(".") < 0 && this[prop] != "") {
          //首位是0的话去掉
          this[prop] = parseFloat(this[prop]);
        }
      } else {
        this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
        this[prop] = this[prop].replace(/[^\d]/g, "");
        this[prop] = this[prop]
          .replace(".", "")
          .replace("-", "")
          .replace(",", "");
      }
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    // 过滤大于0且如果是小数保留两位
    filterGtrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this[prop].length == 1) {
        this[prop] = this[prop].replace(/[^0-9]/g, "");
      } else {
        this[prop] = this[prop].replace(/^(0+)|\D/g, "");
      }
    },
    // 批量设置
    showBatchDialog() {
      if (this.checkedGoods.length) {
        this.batchDialogVisible = true;
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    // 删除选择商品
    deleteSelectedSuperpositionGift(){
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedSuperpositionGift = this.selectedSuperpositionGift.filter(
            v =>
              !this.checkedGoods.some(
                item => v.attrId === item.attrId
              )
          );
          this.superpositionGiftResult = this.selectedSuperpositionGift;
          this.checkedGoods = [];
          this.checkAll = false;
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    deleteSelectedFullDelivery() {
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedFullDeliveryGoods = this.selectedFullDeliveryGoods.filter(
            v =>
              !this.checkedGoods.some(
                item => v.attrId === item.attrId && !v.isSame
              )
          );
          this.fullDeliveryResult = this.selectedFullDeliveryGoods;
          this.checkedGoods = [];
          this.checkAll = false;
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    deleteSelectedCombination() {
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedCombination = this.selectedCombination.filter(
            v => !this.checkedGoods.some(item => v.attrId === item.attrId)
          );
          this.combinationResult = this.selectedCombination;
          this.checkedGoods = [];
          this.checkAll = false;
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    deleteSelectedIncreasePurchase() {
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedIncreasePurchase = this.selectedIncreasePurchase.filter(
            v => !this.checkedGoods.some(item => v.attrId === item.attrId)
          );
          this.increasePurchaseResult = this.selectedIncreasePurchase;
          this.checkedGoods = [];
          this.checkAll = false;
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    deleteSelectedListHot() {
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedListHot = this.selectedListHot.filter(
            v => !this.checkedGoods.some(item => v.attrId === item.attrId)
          );
          this.listHot = this.selectedListHot;
          this.checkedGoods = [];
          this.checkAll = false;
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    getChecked(selection) {
      this.checkedGoods = selection;
    },
    getCheckedAdd(selection){
      this.checkedRow = selection;
    },
    handleCheckAllChange(val) {
      switch (this.parentId) {
        case "FullDelivery":
          this.checkedGoods = val ? this.fullDeliveryResult : [];
          break;
        case "FullDeliveryOverlay":
          this.checkedGoods = val ? val : [];

          break;
        case "SpecialPrice":
          this.checkedGoods = val ? this.listHot : [];
          break;
        case "IncreasePurchase":
          this.checkedGoods = val ? this.increasePurchaseResult : [];
          break;
        case "CombinationPrice":
          this.checkedGoods = val ? this.combinationResult : [];
          break;
        case "SuperpositionGift":
          this.checkedGoods = val ? this.superpositionGiftResult : [];
          break;  
        default:
          break;
      }
      this.isIndeterminate = false;
    },
    handleCheckedGoodsChange(value) {
      let checkedCount = value.length;
      switch (this.parentId) {
        case "FullDelivery":
          this.checkAll = checkedCount === this.fullDeliveryResult.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.fullDeliveryResult.length;
          break;
        case "FullDeliveryOverlay":
          this.checkAll = checkedCount === this.fullDeliveryResult.length;

          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.fullDeliveryResult.length;

          break;
        case "SpecialPrice":
          this.checkAll = checkedCount === this.listHot.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.listHot.length;
          break;
        case "IncreasePurchase":
          this.checkAll = checkedCount === this.increasePurchaseResult.length;
          this.isIndeterminate =
            checkedCount > 0 &&
            checkedCount < this.increasePurchaseResult.length;
          break;
        case "CombinationPrice":
          this.checkAll = checkedCount === this.combinationResult.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.combinationResult.length;
          break;
        default:
          break;
      }
    },
    filterDeliveryGoods() {
      this.fullDeliveryResult = this.selectedFullDeliveryGoods.filter(
        v =>
          v.attrValue.includes(this.keywords) ||
          v.attrId.includes(this.keywords)
      );
    },
    filterIncreaseGoods() {
      this.increasePurchaseResult = this.selectedIncreasePurchase.filter(
        v =>
          v.attrValue.includes(this.keywords) ||
          v.attrId.includes(this.keywords)
      );
    },
    filterSpecialGoods() {
      this.listHot = this.selectedListHot.filter(
        v =>
          v.attrValue.includes(this.keywords) ||
          v.attrId.includes(this.keywords)
      );
    },
    filterSuperpositionGift() {
      this.superpositionGiftResult = this.selectedSuperpositionGift.filter(
        v =>
          v.attrValue.includes(this.keywords) ||
          v.attrId.includes(this.keywords)
      );
    },
    deleteCurrentDeliveryGoods(v, i) {
      this.fullDeliveryResult.splice(i, 1);
    },
    deleteCurrentCombinationGoods(v, i) {
      this.combinationResult.splice(i, 1);
    },
    deleteCurrentIncreasePurchase(v, i) {
      this.increasePurchaseResult.splice(i, 1);
    },
    deleteCurrentListHot(v, i) {
      this.listHot.splice(i, 1);
    },
    deleteCurrentSuperpositionGif(v, i) {
      this.superpositionGiftResult.splice(i, 1);
    },
    showTransfer() {
      this.dialogVisible = true;
      this.showMustDelivery = true;
      this.$nextTick(() => {
        this.$refs.ruleTransfer.rightChecked = [];
      });
    },
    handleSelectionChange() {},
    saveSelectedGoods() {
      let rightChecked = this.$refs.ruleTransfer.rightChecked;
      rightChecked.forEach(v => {
        v.shopPrices = v.shopPrice;
      });
      switch (this.parentId) {
        // 满送
        case "FullDelivery":
          if (
            (rightChecked.find(o => o.attrType === "attribute") &&
              rightChecked.find(o => o.attrType !== "attribute")) ||
            (rightChecked.find(o => o.attrType === "attribute") &&
              this.fullDeliveryResult.find(o => o.attrType !== "attribute")) ||
            (rightChecked.find(o => o.attrType !== "attribute") &&
              this.fullDeliveryResult.find(o => o.attrType === "attribute"))
          ) {
            this.$message({
              type: "error",
              message: "标签不能与品牌、品类、商品共存！"
            });
          } else {
            this.$refs.ruleTransfer.rightChecked.forEach(v => {
              this.$set(v, "selectUpperLimit", 1);
            });
            if (this.selectType === "mix") {
              this.selectedFullDeliveryGoods = this.selectedFullDeliveryGoods.concat(
                this.$refs.ruleTransfer.rightChecked
              );

              this.selectedFullDeliveryGoods.forEach(v => {
                v.selectUpperLimit = 1;

                v.goodsPackageNum = 1;
              });
            } else if (this.selectType === "same") {
              let isNotMustDeliveryList = this.$refs.ruleTransfer.rightChecked;
              isNotMustDeliveryList.forEach(v => {
                v.selectUpperLimit = 1;
                this.$set(v, "selectUpperLimit", 1);
                v.isMustDelivery = "no";
              });
              this.selectedFullDeliveryGoods = this.selectedFullDeliveryGoods.concat(
                isNotMustDeliveryList
              );
            }
            this.selectedFullDeliveryGoods = arrayUnique2(
              this.selectedFullDeliveryGoods,
              "attrId"
            );
            this.fullDeliveryResult = this.selectedFullDeliveryGoods;
          }
          break;
        // 满送叠加
        case "FullDeliveryOverlay":
          if (
            (rightChecked.find(o => o.attrType === "attribute") &&
              rightChecked.find(o => o.attrType !== "attribute")) ||
            (rightChecked.find(o => o.attrType === "attribute") &&
                this.fullDeliveryResult && this.fullDeliveryResult.find(o => o.attrType !== "attribute")) ||
            (rightChecked.find(o => o.attrType !== "attribute") &&
                this.fullDeliveryResult && this.fullDeliveryResult.find(o => o.attrType === "attribute"))
          ) {
            this.$message({
              type: "error",
              message: "标签不能与品牌、品类、商品共存！"
            });
          } else {
            this.$refs.ruleTransfer.rightChecked.forEach(v => {
              this.$set(v, "selectUpperLimit", 1);
            });
            if (this.selectType === "mix") {
              this.selectedFullDeliveryGoods = this.selectedFullDeliveryGoods.concat(
                this.$refs.ruleTransfer.rightChecked
              );
              this.selectedFullDeliveryGoods.forEach(v => {
                v.selectUpperLimit = 1;
                this.$set(v, "selectUpperLimit", 1);
                v.goodsPackageNum = 1;
              });
            } else if (this.selectType === "same") {
              let isNotMustDeliveryList = this.$refs.ruleTransfer.rightChecked;
              isNotMustDeliveryList.forEach(v => {
                v.selectUpperLimit = 1;
                this.$set(v, "selectUpperLimit", 1);
                v.isMustDelivery = "no";
              });
              this.selectedFullDeliveryGoods = this.selectedFullDeliveryGoods.concat(
                isNotMustDeliveryList
              );
            }
            this.selectedFullDeliveryGoods = arrayUnique2(
              this.selectedFullDeliveryGoods,
              "attrId"
            );
            this.fullDeliveryResult = this.selectedFullDeliveryGoods;
          }
          break;
        case "IncreasePurchase":
          this.selectedIncreasePurchase = this.selectedIncreasePurchase.concat(
            this.$refs.ruleTransfer.rightChecked
          );
          this.$refs.ruleTransfer.rightChecked.forEach(v => {
            this.$set(v, "selectUpperLimit", 1);
          });
          this.selectedIncreasePurchase.forEach(v => {
            v.selectUpperLimit = 1;
            this.$set(v, "selectUpperLimit", 1);
          });
          this.selectedIncreasePurchase = arrayUnique2(
            this.selectedIncreasePurchase,
            "attrId"
          );
          this.increasePurchaseResult = this.selectedIncreasePurchase;
          break;
        case "CombinationPrice":
          this.selectedCombination = this.selectedCombination.concat(
            this.$refs.ruleTransfer.rightChecked
          );
          this.selectedCombination = arrayUnique2(
            this.selectedCombination,
            "attrId"
          );
          this.combinationResult = this.selectedCombination;
          break;
        case "SpecialPrice":
          this.$refs.ruleTransfer.rightChecked.forEach(v => {
            this.$set(v, "purchasesUpperLimit", "");
            this.$set(v, "totalStockNum", "");
            this.$set(v, "discountRatio", "");
            this.$set(v, "discountPrice", "");
          });

          this.selectedListHot = this.selectedListHot.concat(
            this.$refs.ruleTransfer.rightChecked
          );
          this.selectedListHot = arrayUnique2(this.selectedListHot, "attrId");

          this.listHot = this.selectedListHot;
          break;
        // 叠加赠送
        case "SuperpositionGift":
          console.log("进入叠加赠送")
          if (
            (rightChecked.find(o => o.attrType === "attribute") &&
              rightChecked.find(o => o.attrType !== "attribute")) ||
            (rightChecked.find(o => o.attrType === "attribute") &&
              this.fullDeliveryResult.find(o => o.attrType !== "attribute")) ||
            (rightChecked.find(o => o.attrType !== "attribute") &&
              this.fullDeliveryResult.find(o => o.attrType === "attribute"))
          ) {
            this.$message({
              type: "error",
              message: "标签不能与品牌、品类、商品共存！"
            });
          } else {
            this.$refs.ruleTransfer.rightChecked.forEach(v => {
              this.$set(v, "selectUpperLimit", 1);
            });
            if (this.pasSuperpositionGiftRuleLimitModel.giftMode === "num") {
              this.selectedSuperpositionGift = this.selectedSuperpositionGift.concat(
                this.$refs.ruleTransfer.rightChecked
              );

              this.selectedSuperpositionGift.forEach(v => {
                v.selectUpperLimit = 9999;
                v.selectUpperNum = 1;
                v.goodsPackageNum = 1;
              });
            }
            this.selectedSuperpositionGift = arrayUnique2(
              this.selectedSuperpositionGift,
              "attrId"
            );
            this.superpositionGiftResult = JSON.parse(JSON.stringify(this.selectedSuperpositionGift));
          }
          break;  
        default:
          break;
      }
      this.dialogVisible = false;
      this.$refs.ruleTransfer.rightChecked = [];
      this.$refs.ruleTransfer.rightData = [];
    },
    saveSelected() {
      let rightChecked = this.checkedRow;
      console.log("this.checkedRow:",this.checkedRow);
      switch (this.parentId) {
        // 叠加赠送
        case "SuperpositionGift":
          console.log("进入叠加赠送")
            this.checkedRow.forEach(v => {
              this.$set(v, "selectUpperLimit", 1);
            });
            if (this.pasSuperpositionGiftRuleLimitModel.giftMode === "num") {
              this.selectedSuperpositionGift = this.selectedSuperpositionGift.concat(
                this.checkedRow
              );

              this.selectedSuperpositionGift.forEach(v => {
                v.selectUpperLimit = 9999;
                v.selectUpperNum = 1;
                v.goodsPackageNum = 1;
              });
            }
            this.selectedSuperpositionGift = arrayUnique2(
              this.selectedSuperpositionGift,
              "attrId"
            );
            this.superpositionGiftResult = JSON.parse(JSON.stringify(this.selectedSuperpositionGift));;
            console.log("this.superpositionGiftResult:",this.superpositionGiftResult);
          break;  
        default:
          break;
      }
      this.dialogVisibleSku = false;
    },
    // 切换必选与非必选开关
    swithcSelect() {
      this.$forceUpdate();
    },
    cookieEcho(step4) {
      if (step4) {
        switch (this.parentId) {
          // 满额减金额，减件数
          case "FullReduction":
            this.fullReductionRule = step4;
            break;
          // 满件数叠加送商品，满金额叠加送商品
          case "FullDeliveryOverlay":
            this.overlayType = step4.fullDeliveryOverlayRuleModel.overlayType;
            this.selectType = step4.fullDeliveryOverlayRuleModel.selectType;

            setTimeout(() => {
              this.chooseDeliveryAmount =
                step4.fullDeliveryOverlayRuleModel.selectLowerLimit;

              this.mustDeliveryAmount =
                step4.fullDeliveryOverlayRuleModel.mustDeliveryAmount;
              this.purchasesAmount =
                step4.fullDeliveryOverlayRuleModel.purchasesAmount;
              this.sendNum = step4.fullDeliveryOverlayRuleModel.sendNum;
              this.maxCycleTimes =
                step4.fullDeliveryOverlayRuleModel.maxCycleTimes;
              this.overlayRuleModelList =
                step4.fullDeliveryOverlayRuleModel.overlayRuleModelList;
              console.log("this.selectType: ", this.selectType);
              if (this.selectType === "mix") {
                step4.fullDeliveryGoods.forEach(v => {
                  v.groupGoods.forEach(o => {
                    o.attrId = o.typeId;
                    o.attrValue = o.typeValue;
                    if (!o.goodsSn) {
                      o.goodsSn = o.typeId;
                      o.goodsName = o.typeValue;
                    }
                  });
                });
                if (this.overlayType === "cycle") {
                  for (let key in step4.fullDeliveryOverlayRuleModel
                    .overlayRuleModelList[0]) {
                    if (key !== "selectType") {
                      this[key] =
                        step4.fullDeliveryOverlayRuleModel.overlayRuleModelList[0][
                          key
                        ];
                    }
                  }
                }
                this.fullDeliveryGoods = step4.fullDeliveryGoods;
                this.chooseDeliveryAmount =
                  step4.fullDeliveryGoods[0].selectLowerLimit;
                // if (this.fullDeliveryGoods[0].groupGoods.length === 0) {
                //   this.fullDeliveryGoods = [];
                // }
                this.fullDeliveryResult = step4.fullDeliveryResult;
                this.giftLimit =
                  step4.fullDeliveryGoods[
                    step4.fullDeliveryGoods.length - 1
                  ].giftLimit;
              } else if (this.selectType === "same") {
                let result = [];
                step4.fullDeliveryGoods.map(o => {
                  result = result.concat(o.groupGoods);
                });
                result.forEach(o => {
                  o.attrId = o.attrType === "barcode" ? o.barcode : o.goodsSn;
                  o.attrValue = o.goodsName;
                });
                if (this.overlayType === "cycle") {
                  for (let key in step4.fullDeliveryOverlayRuleModel
                    .overlayRuleModelList[0]) {
                    this[key] =
                      step4.fullDeliveryOverlayRuleModel.overlayRuleModelList[0][
                        key
                      ];
                  }
                }
                result.map(o => {
                  if (
                    this.fullDeliveryResult.find(
                      p => p.attrValue !== o.goodsName || p.attrId !== o.attrId
                    )
                  ) {
                    this.fullDeliveryResult.push(o);
                    this.fullDeliveryResult = arrayUnique2(
                      this.fullDeliveryResult,
                      "attrId"
                    );
                  }
                });
                this.fullDeliveryResult.forEach(v => {
                  if (!v.attrId && v.goodsSn) {
                    v.attrId = v.attrType === "barcode" ? v.barcode : v.goodsSn;
                    v.attrValue = v.goodsName;
                  }
                });
                if (step4.fullDeliveryGoods.length) {
                  this.chooseDeliveryAmount =
                    step4.fullDeliveryGoods[0].selectLowerLimit;
                }

                this.giftLimit =
                  this.overlayType === "no"
                    ? step4.fullDeliveryGoods[
                        step4.fullDeliveryGoods.length - 1
                      ].giftLimit
                    : "";
              }
            }, 0);
            break;
          // 满件数送商品，满金额送商品
          case "FullDelivery":
            this.selectType = step4.fullDeliveryRule.selectType;
            // 防止watch改变数据
            setTimeout(() => {
              if (this.selectType === "mix") {
                this.purchasesAmount = step4.fullDeliveryRule.purchasesAmount;
                step4.fullDeliveryGoods.forEach(v => {
                  v.groupGoods.forEach(o => {
                    o.attrId = o.typeId;
                    o.attrValue = o.typeValue;
                    if (!o.goodsSn) {
                      o.goodsSn = o.typeId;
                      o.goodsName = o.typeValue;
                    }
                  });
                });
                this.fullDeliveryGoods = step4.fullDeliveryGoods;

                this.chooseDeliveryAmount =
                  step4.fullDeliveryGoods[
                    step4.fullDeliveryGoods.length - 1
                  ].selectLowerLimit;
                this.fullDeliveryResult = step4.fullDeliveryResult;
                this.giftLimit =
                  step4.fullDeliveryGoods[
                    step4.fullDeliveryGoods.length - 1
                  ].giftLimit;
              } else if (this.selectType === "same") {
                this.purchasesAmount = step4.fullDeliveryRule.purchasesAmount;
                this.chooseDeliveryAmount =
                  step4.fullDeliveryGoods[
                    step4.fullDeliveryGoods.length - 1
                  ].selectLowerLimit;
                let result = [];
                step4.fullDeliveryGoods.map(o => {
                  result = result.concat(o.groupGoods);
                });
                // result.forEach(o => {
                //   o.attrId = o.attrType === "barcode" ? o.barcode : o.goodsSn;
                //   o.attrValue = o.goodsName;
                // });

                // result.map(o => {
                //   if (
                //     this.fullDeliveryResult.find(
                //       p => p.attrValue !== o.goodsName || p.attrId !== o.attrId
                //     )
                //   ) {
                //     this.fullDeliveryResult.push(o);
                //     this.fullDeliveryResult = arrayUnique2(
                //       this.fullDeliveryResult,
                //       "attrId"
                //     );
                //   }
                // });
                // this.fullDeliveryResult.forEach(v => {
                //   if (!v.attrId && v.goodsSn) {
                //     v.attrId = v.attrType === "barcode" ? v.barcode : v.goodsSn;
                //     v.attrValue = v.goodsName;
                //   }
                // });
                this.giftLimit =
                  step4.fullDeliveryGoods[
                    step4.fullDeliveryGoods.length - 1
                  ].giftLimit;
              }
            }, 0);
            break;
          // 满件数加价换购
          case "IncreasePurchase":
            this.increasePurchaseRules = step4;
            break;
          // 满件数打折
          case "FullDiscount":
            this.discountMode = step4.discountMode;
            if (this.discountMode === "fullPriceDiscount") {
              this.fullDiscountRule = step4.list;
            } else if (this.discountMode === "floorPriceDiscount") {
              this.purchasesAmount = step4.purchasesAmount;
              this.discountRatio = step4.discountRatio;
            }
            break;
          // 特价
          case "SpecialPrice":
            this.listHot = arrayUnique2(step4, "attrId");
            this.selectedListHot = arrayUnique2(step4, "attrId");
            if(this.listHot.length){
            this.showUpperNum = this.listHot[0].showUpperNum.toString();
            console.log("this.showUpperNum",this.showUpperNum);
            }
            break;
          // 打包价
          case "CombinationPrice":
            this.combinationPriceRules = step4.combinationPriceRules;
            this.combinationResult = step4.combinationPriceGoods;
            break;
          // 叠加赠送
          case "SuperpositionGift":
            this.pasSuperpositionGiftRuleGoodsModelListResult = step4.pasSuperpositionGiftRuleGoodsModelList;
            this.pasSuperpositionGiftRuleLimitModel = step4.pasSuperpositionGiftRuleLimitModel;
            console.log("执行step4:",step4);
            break;  
          default:
            break;
        }
      }
    },
    getDiscountPrice(v, i) {
      if (this.parentId === "SpecialPrice" && new Number(v) >= 10) {
        this.$message({
          message: "折扣率需小于10",
          type: "warning"
        });
        this.$set(this.listHot[i], "discountRatio", "");
        return;
      }
      const result = +(this.listHot[i].shopPrices * v) / 10;
      if (Number.isInteger(result)) {
        // this.listHot[i].discountPrice = result;
        this.$set(this.listHot[i], "discountPrice", result);
      } else {
        // this.listHot[i].discountPrice = +result.toFixed(2);
        this.$set(this.listHot[i], "discountPrice", +result.toFixed(2));
      }
      this.$forceUpdate();
    },
    getDiscount(v, i) {
      const result = (v / this.listHot[i].shopPrices) * 10;
      if (Number.isInteger(result)) {
        // this.listHot[i].discountRatio = result;
        this.$set(this.listHot[i], "discountRatio", result);
      } else {
        // this.listHot[i].discountRatio = +result.toFixed(2);
        this.$set(this.listHot[i], "discountRatio", +result.toFixed(2));
      }

      this.$forceUpdate();
    },
    saveCookie() {
      const data = getCookie({ key: "STEP" });

      if (data) {
        switch (this.parentId) {
          // 满额减金额，减件数
          case "FullReduction":
            data.step4 = this.fullReductionRule;
            break;
          // 满件数送商品，满金额送商品
          case "FullDelivery":
            this.createFullDeliveryGoods();
            // this.fullDeliveryGoods.forEach(o => {
            //   o.groupGoods.map(v => {
            //     v.goodsSn = v.attrId || v.goodsSn;
            //     v.goodsName = v.attrValue || v.goodsName;
            //   });
            // });

            data.step4 = {
              fullDeliveryResult: this.fullDeliveryResult,
              fullDeliveryGoods: this.fullDeliveryGoods,
              fullDeliveryRule: {
                chooseDeliveryAmount: this.chooseDeliveryAmount,
                mustDeliveryAmount: this.mustDeliveryAmount,
                purchasesAmount: this.purchasesAmount,
                selectType: this.selectType
              }
            };
            break;
          // 满件数叠加送商品，满金额叠加送商品
          case "FullDeliveryOverlay":
            this.createFullDeliveryOverlayGoods();
            // this.fullDeliveryGoods.forEach(o => {
            //   o.groupGoods.map(v => {
            //     v.goodsSn = v.attrId || v.goodsSn;
            //     v.goodsName = v.attrValue || v.goodsName;
            //   });
            // });
            data.step4 = {
              fullDeliveryGoods: this.fullDeliveryGoods,
              fullDeliveryResult: this.fullDeliveryResult,
              fullDeliveryOverlayRuleModel: {
                overlayRuleModelList: this.overlayRuleModelList,
                selectLowerLimit: this.chooseDeliveryAmount,
                mustDeliveryAmount: this.mustDeliveryAmount,
                purchasesAmount: this.purchasesAmount,
                maxCycleTimes: this.maxCycleTimes,
                sendNum: this.sendNum,
                selectType: this.selectType,
                overlayType: this.overlayType
              }
            };
            break;
          // 满件数加价换购
          case "IncreasePurchase":
            data.step4 = this.increasePurchaseRules;
            break;
          // 满件数打折
          case "FullDiscount":
            if (this.discountMode === "fullPriceDiscount") {
              data.step4 = {
                discountMode: this.discountMode,
                list: this.fullDiscountRule
              };
            } else if (this.discountMode === "floorPriceDiscount") {
              data.step4 = {
                discountMode: this.discountMode,
                calcCondition: this.calcCondition,
                discountRatio: this.discountRatio
              };
            }
            break;
          // 特价
          case "SpecialPrice":
            data.step4 = this.listHot;
            break;
          // 打包价
          case "CombinationPrice":
            data.step4 = {
              combinationPriceRules: this.combinationPriceRules,
              combinationPriceGoods: this.combinationResult
            };
            break;
          default:
            break;
        }
        setCookie({ key: "STEP", data });
      }
    },
    batchSetting() {
      this.listHot.forEach(v => {
        v.totalStockNum = this.totalStockNum;
        v.purchasesUpperLimit = this.purchasesUpperLimit;
        v.discountRatio = this.discountRatio;
        v.discountPrice = Number.isInteger(
          (v.shopPrices * this.discountRatio) / 10
        )
          ? (v.shopPrices * this.discountRatio) / 10
          : +((v.shopPrices * this.discountRatio) / 10).toFixed(2);
      });
      this.batchDialogVisible = false;
    },
    s2ab(s) {
      if (typeof ArrayBuffer !== "undefined") {
        const buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      } else {
        const buf = new Array(s.length);
        for (let i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let fullDeliveryResult = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            fullDeliveryResult = roa.slice(1);
          }
        });
        const formatData = [];
        let isRequired = true;

        if (fullDeliveryResult.length > 0) {
          fullDeliveryResult.forEach(v => {
            if (
              !v[0] ||
              !v[1] ||
              !v[2] ||
              !v[3] ||
              !v[4] ||
              !v[5] | !v[6] | !v[7]
            ) {
              isRequired = false;
            }
            formatData.push({
              goodsSn: v[0],
              goodsName: v[1],
              attrId: v[0],
              attrValue: v[1],
              goodsPackageNum: v[2],
              purchasesUpperLimit: v[3],
              totalStockNum: v[4],
              shopPrices: +ToFixed(v[5] || 0, 2),
              discountRatio: v[6],
              discountPrice: v[7],
              attrType: "goods",
              goodsType: "goods"
            });
          });
        } else {
          isRequired = false;
        }

        if (isRequired) {
          that.listHot = that.listHot.concat(formatData);
          that.listHot = arrayUnique2(that.listHot, "attrId");
        } else {
          that.$message({
            message: "导入失败，请导入完整商品信息！",
            type: "warning"
          });
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导出excel
    outputExcel() {
      const STEP = getCookie({ key: "STEP" });
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        const tHeader = [
          "商品货号",
          "商品名",
          "商品数量",
          "单人限购",
          "促销库存",
          "零售价",
          "折扣率",
          "折扣价"
        ];
        const filterVal = [
          "goodsSn",
          "goodsName",
          "goodsPackageNum",
          "purchasesUpperLimit",
          "totalStockNum",
          "shopPrices",
          "discountRatio",
          "discountPrice"
        ];
        const data = this.formatJson(filterVal, this.listHot);
        exportJsonToExcel(tHeader, data, STEP.step2.promotionName + "商品");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    filterInteger(value, i) {
      this.$set(this.fullDeliveryResult[i], "selectUpperLimit", value);
      if (value.length == 1) {
        this.fullDeliveryResult[i].selectUpperLimit = +value.replace(
          /[^1-9]/g,
          ""
        );
      } else {
        this.fullDeliveryResult[i].selectUpperLimit = +value.replace(/\D/g, "");
      }
    },
    filterSelectUpperLimitSuperpositionGift(value, i) {
      this.$set(this.superpositionGiftResult[i], "selectUpperLimit", value);
      console.log("value.length1:",value.length);
      if (value.length == 1) {
        this.superpositionGiftResult[i].selectUpperLimit = +value.replace(
          /[^1-9]/g,
          ""
        );
      } else {
        this.superpositionGiftResult[i].selectUpperLimit = +value.replace(/\D/g, "");
      }
    },
    filterSelectUpperNumSuperpositionGift(value, i) {
      this.$set(this.superpositionGiftResult[i], "selectUpperNum", value);
      console.log("value.length2:",value.length);
      if (value.length == 1) {
        this.superpositionGiftResult[i].selectUpperNum = +value.replace(
          /[^1-9]/g,
          ""
        );
      } else {
        this.superpositionGiftResult[i].selectUpperNum = +value.replace(/\D/g, "");
      }
    },
    filterIntegerFunc(val) {
      this[val] = this[val].replace(/\./g, "");
    },
    filterIntegerByIncrease(value, i) {
      if (value.length == 1) {
        this.increasePurchaseResult[i].selectUpperLimit = +value.replace(
          /[^1-9]/g,
          ""
        );
      } else {
        this.increasePurchaseResult[i].selectUpperLimit = +value.replace(
          /\D/g,
          ""
        );
      }
    },
    add(type, title) {
      if (type === "goods") {
        this.searchCondition = {
          queryType: "spu_name"
        };
      } else {
        this.searchCondition = {};
      }
      this.addList = [];
      this.totalAdd = 0;
      this.title = title;
      this.type = type;
      this.queryAddList();
      this.dialogVisibleSku = true;
    },
    searchAdd() {
      this.currentPageAdd = 1;
      this.queryAddList();
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryAddList();
    },
    handleSizeChangeAdd(size) {
      this.pageSizeAdd = size;
      this.currentPageAdd = 1;
      this.queryAddList();
    },
    pagingAdd(page) {
      this.currentPageAdd = page;
      this.queryAddList();
    },
    async queryAddList() {
      let params = {
        pageNo: this.currentPageAdd,
        pageSize: this.pageSizeAdd,
        isSupplier: "no",
        isOverseas: "no",
        sales_state: "up",
        bindState: "true",
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);      
      const { result } = await this.$store.dispatch(
        "queryWxshopSkuInfoListWithPage",
        params
      );
      this.addList = result.records;
      this.addList.forEach(v => {
        v.attrValue = v.spuName;
        v.attrId = v.specBarcode;
        v.attrType = "barcode";
        v.goodsName = v.spuName;
        v.barcode = v.specBarcode;
        v.shopPrices = v.wxshopPrice;
      });
      this.totalAdd = result.total;
      console.log("this.addList:",this.addList);
      this.$nextTick(() => {
        this.addList.map(v => {
          if (this.superpositionGiftResult.findIndex(o => o.attrId === v.attrId) >= 0) {
            this.$refs.table.toggleRowSelection(v);
          }
        });
      });
    },
    addSelected(useable) {
      let rightChecked =
        this.type === "brand" ||
        this.type === "goods" ||
        this.type === "barcode"
          ? this.checkedRow
          : this.getSimpleCheckedNodes(this.$refs.tree.store);

      if (
        (rightChecked.find(o => o.attrType === "attribute") &&
          rightChecked.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType === "attribute") &&
          this.selectedData.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType !== "attribute") &&
          this.selectedData.find(o => o.attrType === "attribute"))
      ) {
        this.$message({
          type: "error",
          message: "属性标签不能与品牌、品类、商品共存！"
        });
      } else {
        if (
          this.type === "brand" ||
          this.type === "goods" ||
          this.type === "barcode"
        ) {
          if (this.checkedRow.length) {
            this.checkedRow.forEach(v => {
              v.useable = useable;
            });
            const data = this.selectedData.concat(this.checkedRow);
            this.selectedData = [...new Set(data)];
            this.selectedData = arrayUnique2(this.selectedData, "attrId");
            this.result = this.selectedData;
            this.dialogVisible = false;
            this.checkedRow = [];
          } else {
            this.$message({
              type: "error",
              message: "请选择"
            });
          }
        } else {
          const checkCateGoryList = this.getSimpleCheckedNodes(
            this.$refs.tree.store
          );

          if (checkCateGoryList.length) {
            checkCateGoryList.forEach(v => {
              v.useable = useable;
            });
            const data = this.selectedData.concat(checkCateGoryList);
            this.selectedData = [...new Set(data)];
            this.selectedData = arrayUnique2(this.selectedData, "attrId");
            this.result = this.selectedData;
            this.drawer = false;
          } else {
            this.$message({
              type: "error",
              message: "请选择"
            });
          }
        }
      }
    },
  },
  components: { HmStep, HmTransfer, ShopPicker }
};
</script>
<style lang="scss">
.list-item {
  .el-checkbox {
    margin: 0;
  }
  .el-checkbox__label {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
.way {
  .way-item {
    .el-select {
      .el-input {
        width: 80px;
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
          padding: 0;
          text-align: center;
        }
      }
    }
    .item {
      .el-input {
        width: 60px;
        .el-input__inner {
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
          padding: 0;
          text-align: center;
        }
      }
    }
  }
  .panel {
    .el-input__inner {
      background: transparent;
    }
  }
}

.table {
  // .el-input {
  //   // width: 60px;
  // }
  .primary {
    .el-input__inner {
      color: #e50065;
    }
  }
  .el-checkbox__label {
    padding-left: 0;
  }
}
</style>
<style lang="scss" scoped>
.checkboxnone {
  .el-table__header-wrapper .el-checkbox {
    //找到表头那一行，然后把里面的复选框隐藏掉
    display: none;
  }
}
.panel {
  position: relative;
  padding: 10px 20px;
  color: #000;
  margin-bottom: 20px;
  background: #f4f4f4;
  box-sizing: border-box;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
  }
}
.preview-dialog {
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
}
.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}

.way {
  margin-top: 20px;
  font-size: 14px;
  .title {
    height: 40px;
    line-height: 40px;
    margin-right: 40px;
  }

  .way-item {
    margin-bottom: 20px;
    .content {
      padding-top: 12px;
    }
  }
}
.tables {
  margin: 20px 0;
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      padding-left: 26px;
    }
  }
  .table-body {
    font-size: 12px;
    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
}

.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}

.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
}
.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
}
</style>
